// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.develop-is.editmode {
  padding: 5px 60px;
  background: #ebebeb;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is.editmode {
    padding: 40px 0 0;
  }
}
::ng-deep.develop-is.editmode .mainnav {
  margin: 0 0 15px;
}
::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li {
  border-radius: 5px;
  height: 31px;
  margin-left: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li {
    display: none;
  }
  ::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li:first-child {
    display: block;
  }
}
::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li svg {
  cursor: pointer;
}
::ng-deep.develop-is .highlight {
  background-color: #B4D5FF;
}
::ng-deep.develop-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-wrap: nowrap;
  margin: 30px 0 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav {
    margin: 10px 0 30px;
  }
}
::ng-deep.develop-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.develop-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav.mainnav--bottom ul li a {
    padding: 11px 5px;
    font-size: 11px;
  }
}
::ng-deep.develop-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
}
::ng-deep.develop-is .mainnav__editmodeicon {
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav__editmodeicon {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.develop-is .mainnav__editmodeicon ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  height: 100%;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li {
  list-style: none;
  transition: none;
  width: 37px;
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #CFDBE2;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.active {
  background-color: #676a6c;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li:not(:last-child) {
  margin-right: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .mainnav__editmodeicon ul li:not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .mainnav__editmodeicon ul li {
    width: 35px;
    height: 31px;
    display: none;
  }
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin {
  display: flex;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st0 {
  fill: #FFFFFF;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st1 {
  fill: #cfdbe2;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st0 {
  fill: #6d6e71;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.listView svg .st0, ::ng-deep.develop-is .mainnav__editmodeicon ul li.individualView svg .st0, ::ng-deep.develop-is .mainnav__editmodeicon ul li.gridView svg .st0 {
  fill: #6d6e71;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.listView svg .st1, ::ng-deep.develop-is .mainnav__editmodeicon ul li.individualView svg .st1, ::ng-deep.develop-is .mainnav__editmodeicon ul li.gridView svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.develop-is .mainnav.editnav {
  justify-content: space-between;
  align-items: center;
  background: #EBEBEB;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav.editnav {
    flex-direction: column;
  }
}
::ng-deep.develop-is .mainnav.editnav ul {
  background-color: #ebebeb;
  border-radius: 5px;
  width: 100%;
  flex: 1;
}
::ng-deep.develop-is .mainnav.editnav ul .develop.active {
  background-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .mainnav.editnav ul li {
  background-color: #fff;
  width: 100%;
}
::ng-deep.develop-is .mainnav.editnav ul li a {
  padding: 5px 2px;
  width: 100%;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav.editnav .editmode_icons {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.develop-is .info {
  color: #fff;
  border: 1px solid rgb(105, 190, 40);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .info.infotitle {
  background-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info.infotitle h3 {
  color: #fff;
}
::ng-deep.develop-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.develop-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.develop-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.develop-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.develop-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.develop-is .info .card__toprow .card__topcol--full {
  width: 100% !important;
}
::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol--tt {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(3) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(3) {
    width: auto;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tt {
  margin-left: auto;
  text-align: right;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--startexist {
  width: 65%;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--startexist + div {
  width: 35%;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(105, 190, 40);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(105, 190, 40);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(105, 190, 40);
  opacity: 1;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.develop-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(105, 190, 40);
  background-color: transparent;
  padding: 2px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(105, 190, 40);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.develop-is .info .card__toprow .card__h3button.disabled {
  cursor: not-allowed;
}
::ng-deep.develop-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.develop-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.develop-is .info .card__toprow .tooltipicon i {
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.develop-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(105, 190, 40);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.develop-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(105, 190, 40);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.develop-is .info h3 .card__bwnh3title {
  margin-right: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.develop-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.develop-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.develop-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.develop-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.develop-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.develop-is .info h3 a {
  margin-left: 10px;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info h3 > a {
  margin-left: 0px;
}
::ng-deep.develop-is .info h3.d-flex {
  display: flex;
}
::ng-deep.develop-is .info h3.d-flex div:first-child {
  padding-right: 10px;
}
::ng-deep.develop-is .info h3.d-flex div:nth-child(2) span {
  display: block;
}
::ng-deep.develop-is .info .tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.develop-is .info .tooltipicon i {
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.develop-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(105, 190, 40);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.develop-is .cn-section-heading {
  display: flex;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 10px;
  padding: 14px 24px;
  background-color: #ecf9e2;
  border-left: 4px solid rgb(105, 190, 40);
  border-radius: 0 6px 6px 0;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .cn-section-heading {
    padding: 12px 16px;
    margin-top: 30px;
  }
}
::ng-deep.develop-is .cn-section-heading__title {
  font-size: 22px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(105, 190, 40);
  margin: 0;
  line-height: 1.3;
  letter-spacing: 0.5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .cn-section-heading__title {
    font-size: 18px;
  }
}
::ng-deep.develop-is .cn-section-heading__btn {
  margin-left: 16px;
  padding: 6px 20px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #fff;
  background-color: rgb(105, 190, 40);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
::ng-deep.develop-is .cn-section-heading__btn:hover {
  opacity: 0.85;
}
::ng-deep.develop-is app-develop-challenge-top-ideas,
::ng-deep.develop-is app-develop-challenge-solution-prototype,
::ng-deep.develop-is app-develop-challenge-pluses,
::ng-deep.develop-is app-develop-challenge-opportunities,
::ng-deep.develop-is app-develop-challenge-issues,
::ng-deep.develop-is app-develop-challenge-new-thinking,
::ng-deep.develop-is app-develop-challenge-solution {
  display: block;
  margin-top: 30px;
}
::ng-deep.develop-is app-develop-challenge-pluses {
  margin-top: 10px;
}
::ng-deep.develop-is app-develop-challenge-solution {
  margin-top: 40px;
}
::ng-deep.develop-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.develop-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.develop-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.develop-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.develop-is .card-default.card-default--summary .card-body__inner {
  padding: 15px 20px;
}
::ng-deep.develop-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.develop-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.develop-is .card-default .info {
  margin: 0;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 6px;
}
::ng-deep.develop-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.develop-is .card-default .card-body__inner {
  padding: 15px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.develop-is .card-default .card-body.stCard__body {
  border: none;
}
::ng-deep.develop-is .card-default .card-body.stCard__body .card-body__inner {
  padding: 0 !important;
}
::ng-deep.develop-is .card-default .card-body.stCard__body .card-body__subtitle {
  padding: 0 40px 5px !important;
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.develop-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__finalstate--2, ::ng-deep.develop-is .card-default .card-body__finalstate--row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--2 > div, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div {
  width: 50%;
  padding: 0 10px;
  margin-bottom: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate--2 > div, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div {
    width: 100%;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate--2 > div p, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--2 > div p::before, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.develop-is .card-default .card-body__finalstate--cc {
  display: block;
  column-count: 2;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate--cc {
    column-count: 1;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate--cc > div {
  page-break-inside: avoid;
  break-inside: avoid;
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 {
  margin: 0 -10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 > div {
  width: 50%;
  padding: 0 10px;
  margin-bottom: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate--3 > div {
    width: 100%;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.develop-is .card-default .card-body__listwidthdot ul {
  padding-left: 30px;
}
::ng-deep.develop-is .card-default .card-body__subtitle {
  padding-left: 35px;
  margin-bottom: 16px;
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__subtitle--convtxt {
  padding-left: 31px;
}
::ng-deep.develop-is .card-default .card-body__subtitle > span {
  position: absolute;
  top: 0;
  right: 2px;
  opacity: 0.7;
  cursor: pointer;
}
::ng-deep.develop-is .card-default .card-body__subtitle > span.thinkeyebtn {
  right: 40px;
}
::ng-deep.develop-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.develop-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.develop-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.develop-is .card-default .card-body__strength p.pl20 {
  padding-left: 20px;
}
::ng-deep.develop-is .card-default .card-body__strength > * {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__strength > * + * {
  margin-top: 4px;
}
::ng-deep.develop-is .card-default .card-body__strength + div {
  margin-top: 20px;
}
::ng-deep.develop-is .card-default .card-body__solutionstable {
  margin-bottom: 20px;
}
::ng-deep.develop-is .card-default .card-body__solutionstable table {
  width: 100%;
}
::ng-deep.develop-is .card-default .card-body__solutionstable th,
::ng-deep.develop-is .card-default .card-body__solutionstable td {
  padding: 15px 15px 15px 0;
  vertical-align: top;
  width: 50%;
}
::ng-deep.develop-is .card-default .c-radio label {
  padding-left: 0;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.develop-is .card-default .c-radio label > i {
  position: relative;
  top: 2px;
  margin-right: 6px;
  opacity: 0.6;
}
::ng-deep.develop-is .card-default .c-radio label > span {
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
  display: none;
}
::ng-deep.develop-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(0, 173, 208);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.develop-is .card-default .c-radio input:checked + span {
  border-color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.develop-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.develop-is .card-default .checkbox a i {
  color: #676a6c;
}
::ng-deep.develop-is .card-default .checkbox .fa.fa-check.disabled {
  opacity: 0.7;
}
::ng-deep.develop-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: auto !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .checkbox label {
    font-size: 14px;
  }
}
::ng-deep.develop-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 3px;
}
::ng-deep.develop-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.develop-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.develop-is .card-default .checkbox input:checked + span {
  border-color: rgb(105, 190, 40);
  background-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.develop-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.develop-is .card-default .card-body__button .card-button {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-develop {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-develop:hover {
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover em {
  margin-right: 6px;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body--ebtn {
  margin-top: 15px;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
  font-weight: 900;
  cursor: pointer;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-weight: 900;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--disable {
  opacity: 0.5;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  cursor: pointer;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  color: #000;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--close {
  border-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
  font-weight: 900;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover em {
  margin-right: 6px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
    margin-right: 6px !important;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .strengthen-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.develop-is .card-default .strengthen-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 4px;
  margin-bottom: 15px;
}
::ng-deep.develop-is .card-default .input-tabs.cdk-drag {
  width: 100% !important;
}
::ng-deep.develop-is .card-default .input-tabs.cdk-drag p {
  margin-bottom: 5px;
}
::ng-deep.develop-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(0, 173, 208);
  margin-bottom: 15px;
}
::ng-deep.develop-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-default .footer-line {
  color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-default p {
  font-size: 15px;
}
::ng-deep.develop-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs input,
  ::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs select,
  ::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs input,
  ::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs select {
    font-size: 13px;
  }
}
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__minus--hide,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs .card-body__minus--hide {
  display: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol.hideblk {
  display: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow textarea:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow textarea:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel label,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel label {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
  padding-right: 60px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus-visible,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  margin-bottom: 0;
  font-weight: 900;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 158px;
  padding-right: 15px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect--wd,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect--wd {
  width: 255px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect select:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect select:focus {
  outline: rgb(105, 190, 40);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
    width: 100%;
    padding-right: 0;
    margin-bottom: 10px;
  }
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 195px);
  padding-right: 60px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--wd,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--wd {
  width: calc(100% - 260px);
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce {
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus-visible,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible {
  outline: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .input-group-text,
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .input-group-text {
    top: auto;
    transform: translate(0);
    bottom: 9px;
  }
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.develop-is .card-default .card-body__edit + .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  margin: 0 35px;
  color: #676a6c;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.develop-is .card-default .breakthrough-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.develop-is .card-default .breakthrough-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 4px;
}
::ng-deep.develop-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .input-group-text:hover {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.develop-is .card-default .list-columns > div {
  width: 50%;
}
::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper::before, ::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper::after {
  right: auto;
  left: 100%;
}
::ng-deep.develop-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.develop-is .card-default .list-columns--tc {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 10px;
}
::ng-deep.develop-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.develop-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.develop-is .card-default.editmodeActive {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: none;
  background: #fff;
  padding: 40px 35px;
  position: relative;
}
::ng-deep.develop-is .card-default.editmodeActive--not {
  padding: 0;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.top_idea {
  width: 100%;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol {
    grid-template-columns: 1fr;
  }
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol .EditmodeInputs > f-col-12 {
  height: 100%;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--1 {
  grid-template-columns: 1fr;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--3 > div:nth-child(1) {
  grid-row: 1/3;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--4 > div:nth-child(1) {
  grid-row: 1/4;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--5 > div:nth-child(1) {
  grid-row: 1/5;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--6 > div:nth-child(1) {
  grid-row: 1/6;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--7 > div:nth-child(1) {
  grid-row: 1/7;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.listView {
  width: 100%;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.listView .EditmodeInputs + div {
  margin-top: 15px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.listView .EditmodeInputs .f-col-12 {
  float: none;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 -15px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs {
  flex: 1;
  padding: 0 7px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs {
    flex: none;
    width: 100%;
  }
  ::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs + div {
    margin-top: 15px;
  }
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs .row {
  margin-right: 0;
  margin-left: 0;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 {
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  overflow: hidden;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol {
  padding: 10px 15px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h3,
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h4 {
  margin-bottom: 5px;
  color: rgb(105, 190, 40);
  font-size: 18px;
  white-space: nowrap;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h3 a i,
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h4 a i {
  cursor: pointer;
  font-size: 0.9em;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol--ideateclr h3 {
  color: #676A6C;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol--ideateclr h3 a i {
  color: #676A6C;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol p {
  font-weight: 600;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate {
  position: relative;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate.SolutionHeight span svg {
  transform: rotate(0deg);
  cursor: pointer;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate span {
  position: absolute;
  bottom: -12px;
  right: -5px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate span svg {
  transform: rotate(180deg);
  cursor: pointer;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate.TopIdeasInput span {
  cursor: pointer;
  position: relative;
  top: 0;
  left: 10px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate.TopIdeasInput span svg {
  width: 10px;
  transform: rotate(180deg);
}
::ng-deep.develop-is .card-default.editmodeActive .editinput input:focus, ::ng-deep.develop-is .card-default.editmodeActive .editinput input:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default.ediMode__pf {
  margin-top: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf--wbg {
  background-color: #fff;
}
::ng-deep.develop-is .card-default.ediMode__pf > span {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body--ebtn {
  margin-top: 0;
  padding: 15px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .new-thinking {
  background-color: #fff;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__inner {
  padding: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .info {
  padding: 14px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .info {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter {
  border-bottom: 1px solid #CFDBE2;
  padding-right: 40px;
  padding-bottom: 50px;
  padding-left: 40px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingmobile {
  display: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingmobile {
    display: block;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk {
  padding-left: 13px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk {
    display: none;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk .card-body__ipwrap {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk .card-body__ipcol {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-pincontent {
  overflow-y: auto;
  overflow-x: hidden;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter {
    padding-right: 20px;
    padding-left: 20px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe {
  border-bottom: none;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe > div {
  padding: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 {
  font-size: 25px;
  color: #fff;
  font-family: "Museo-700";
  font-weight: 700;
  white-space: nowrap;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 {
    font-size: 15px;
    padding-left: 35px;
    word-break: break-word;
    white-space: normal;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 6px;
  padding: 6px 8px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 .card__bwnh3ai:hover {
  opacity: 0.7;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 .card__bwnh3ai i {
  font-size: 14px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4::before {
  background-color: #fff;
  color: rgb(105, 190, 40);
  font-family: "Museo-700";
  font-weight: 700;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4::before {
    width: 20px;
    height: 20px;
    font-size: 15px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop {
  background-color: rgb(105, 190, 40);
  position: relative;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card__topcol--tt .tooltipicon__icon {
  color: #fff;
  cursor: pointer;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
  min-height: 40px;
  padding: 6px 24px;
  background-color: #fff;
  color: rgb(105, 190, 40);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
    min-height: auto;
    height: auto;
    width: auto;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button svg .st0 {
  fill: #fff;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt {
  position: relative;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li .card-body__tooltip {
  display: none;
  position: absolute;
  background: #fff;
  color: #676a6c;
  padding: 5px;
  top: -27px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: max-content;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li button:hover {
  opacity: 0.2 !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li:hover .card-body__tooltip, ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li:active .card-body__tooltip {
  display: block;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:first-child {
  width: 245px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .plus h4::before {
  content: "P" !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .opp h4::before {
  content: "O" !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .issue h4::before {
  content: "I" !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .solution_pro_st {
  width: 300px !important;
  margin-left: -40px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .solution_pro_st h4:before {
  display: none;
}
::ng-deep.develop-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.develop-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: rgb(105, 190, 40);
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.develop-is .card-body__pe {
  padding: 0px;
  border: 1px solid #CFDBE2;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  float: none;
}
::ng-deep.develop-is .card-body__pe--npnb {
  border: none;
  margin-bottom: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .pluses {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .pluses form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .opportunities {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .opportunities form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .issues {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .issues form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking .card-body__ipwrap {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking .card-body__ipwrap .card-body__ipcol:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-body__pe .card-body__petop {
  margin-bottom: 13px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol {
  padding: 0 15px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol--full {
  width: 100% !important;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(1) {
    flex: 1;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(2) {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(2) {
    width: 120px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(3) {
  width: 28%;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(3) {
    width: auto;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:first-child {
  width: 215px;
  padding-right: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:first-child {
    width: auto;
    padding-right: 5px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:nth-child(2) {
  width: calc(100% - 216px);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title button.card__h3button {
  border: 1px solid rgb(105, 190, 40);
  background-color: transparent;
  padding: 4px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(105, 190, 40);
  font-size: 22px;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title button.card__h3button:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title button.card__h3button:focus {
  outline: none;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--startexist {
  width: 65%;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li {
  list-style: none;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topactive button {
  color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 14px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid #7bbc43;
  height: auto;
  min-height: 42px;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button svg .st0 {
  fill: rgb(105, 190, 40);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
    padding: 6px 0;
    border: 0 !important;
    width: 0;
    height: 24px;
    min-height: auto;
  }
}
@media only screen and (min-width: 630px) and (max-width: 991px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
    padding: 6px 7px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(105, 190, 40);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button:hover {
  color: rgb(105, 190, 40);
  opacity: 1;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button:hover > span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--info {
  text-align: right;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--info .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--info .tooltipicon i {
  color: #7bbc43;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow p.new-think-issue {
  margin-top: 10px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .convergeMsg {
  width: 33.3333333333%;
}
::ng-deep.develop-is .card-body__pe > div {
  padding: 25px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe > div {
    width: 100%;
  }
}
::ng-deep.develop-is .card-body__pe .pluses {
  border-bottom: 1px solid #CFDBE2;
}
::ng-deep.develop-is .card-body__pe .pluses h4::before {
  content: "P";
}
::ng-deep.develop-is .card-body__pe .opportunities {
  border-bottom: 1px solid #CFDBE2;
}
::ng-deep.develop-is .card-body__pe .opportunities h4::before {
  content: "O";
}
::ng-deep.develop-is .card-body__pe .issues {
  border-bottom: 1px solid #CFDBE2;
}
::ng-deep.develop-is .card-body__pe .issues h4::before {
  content: "I";
}
::ng-deep.develop-is .card-body__pe .new-thinking h4::before {
  content: "Nt";
}
::ng-deep.develop-is .card-body__pe h4 {
  position: relative;
  padding-left: 50px;
  color: rgb(105, 190, 40);
  font-size: 19px;
  margin: 0 0 0;
  font-family: "Open Sans", sans-serif;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe h4 {
    padding-left: 35px;
  }
}
::ng-deep.develop-is .card-body__pe h4::before {
  content: "";
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 20px;
  height: 35px;
  width: 35px;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe h4::before {
    width: 25px;
    height: 25px;
  }
}
::ng-deep.develop-is .card-body__pe h4 small {
  display: block;
  margin-top: 4px;
  color: inherit;
  line-height: 1.3;
  font-size: 14px;
  color: #888;
}
::ng-deep.develop-is .card-body__pe span.fill-bottom {
  width: 100%;
  color: #888;
  font-size: 15px;
}
::ng-deep.develop-is .card-body__pe .icons-right i {
  font-size: 21px;
  color: rgb(105, 190, 40);
  cursor: pointer;
}
::ng-deep.develop-is .card-body__pe .icons-right i:not(:last-child) {
  margin-right: 10px;
}
::ng-deep.develop-is .card-body__pe .fill-input {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
}
::ng-deep.develop-is .card-body__pe .fill-input label {
  display: inline-block;
  min-width: 20px;
}
::ng-deep.develop-is .card-body__pe .fill-input input {
  display: inline-block;
  width: calc(100% - 20px);
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.develop-is .card-body__pe .input-tabs .input-tabs__row {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
  position: relative;
  vertical-align: middle;
}
::ng-deep.develop-is .card-body__pe .input-tabs .input-tabs__row .pr-0 {
  padding-right: 0;
}
::ng-deep.develop-is .card-body__pe .input-tabs .input-tabs__row > i {
  position: absolute;
  top: 50%;
  right: -26px;
  transform: translateY(-50%);
}
::ng-deep.develop-is .card-body__pe .input-tabs label {
  display: inline-block;
  min-width: 20px;
}
::ng-deep.develop-is .card-body__pe .input-tabs input,
::ng-deep.develop-is .card-body__pe .input-tabs select {
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.develop-is .card-body__pe .input-tabs select {
  display: inline-block;
  width: calc(100% - 20px);
}
::ng-deep.develop-is .card-body__pe .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.develop-is .develop-footer-note {
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.develop-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.develop-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.develop-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.develop-is .dotactions {
  position: relative;
}
::ng-deep.develop-is .dotactions .dotactions__inner {
  position: absolute;
  top: 0;
  right: 0;
}
::ng-deep.develop-is .dotactions .dotactions__inner--h {
  top: 5px;
}
::ng-deep.develop-is .dotactions .dotactions__inner--h .dotactions__top {
  cursor: pointer;
  width: 17px;
  justify-content: space-between;
}
::ng-deep.develop-is .dotactions .dotactions__inner--v {
  right: 10px;
  top: 11px;
}
::ng-deep.develop-is .dotactions .dotactions__inner--v .dotactions__top {
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 21px;
  width: 11px;
  align-items: center;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__top {
  padding-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__top span {
  background-color: #adadad;
  width: 3px;
  height: 3px;
  border-radius: 50%;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown {
  display: none;
  background-color: #fff;
  position: absolute;
  top: 100%;
  width: 150px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  right: -5px;
  border-radius: 4px;
  z-index: 9;
  border: 1px solid #ddd;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
  font-size: 11px;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close:hover {
  transform: rotate(360deg);
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 18px;
  background: #fff;
  border: 1px solid #ddd;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin {
  padding: 10px 10px;
  border-radius: 4px;
  min-height: 100%;
  background-color: #f4f4f4;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown > h6 {
  text-align: center;
  margin: 0;
  font-size: 13px;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  font-weight: 400;
  margin-bottom: 2px;
  background-color: #f4f4f4;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown li {
  margin: 0;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown li a {
  padding: 6px 12px;
  color: #656565;
  display: block;
  font-weight: 400;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown li a:hover {
  background-color: rgba(9, 30, 66, 0.04);
}
::ng-deep.develop-is .ideate__ipwrap {
  overflow-x: auto;
  padding: 4px 0 20px !important;
  flex-wrap: nowrap !important;
}
::ng-deep.develop-is .card-body__ipwrap {
  padding: 4px 0 100px;
  margin: 0 -15px 10px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-body__ipwrapm0p0 {
  margin-bottom: 0;
  padding-bottom: 0 !important;
}
::ng-deep.develop-is .card-body__ipwrap--gutter0 {
  margin: 0 !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__ipwrap--scrollx {
  padding-bottom: 20px !important;
  flex-wrap: nowrap;
  overflow-x: auto;
}
::ng-deep.develop-is .card-body__ipwrap--scrollx > div:not(:last-child) {
  margin-right: 30px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn {
  max-width: 250px;
  padding: 0 0;
  width: 100%;
  flex: 0 0 250px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot {
  margin-bottom: 10px;
  margin-bottom: 0;
  border: 1px solid #676a6c;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot > div {
  padding: 10px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot > div p {
  position: relative;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot > div p::before {
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot_converge {
  border: none;
}
::ng-deep.develop-is .card-body__ipwrap.card-body__ipwrap--pb0 {
  padding-bottom: 0;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol {
  padding: 0 15px;
  margin-bottom: 20px;
  width: 50%;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol {
    width: 100%;
  }
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol > .form-control {
  width: calc(100% - 91px);
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend {
  width: 90px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate {
  padding: 0;
  margin-bottom: 0px;
  max-width: 270px;
  width: 100%;
  flex: 0 0 270px;
  -webkit-flex: 0 0 270px;
  -ms-flex: 0 0 270px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate .checkbox {
  padding-right: 22px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate + div {
  margin-left: 30px;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate {
    width: 50%;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate {
    width: 100%;
  }
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate h2 label {
  font-size: 15px;
}
::ng-deep.develop-is .card-body__ipwrap h2 {
  margin-top: 0;
  color: #656565;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}
::ng-deep.develop-is .card-body__ipwrap h2 label {
  display: inline-block;
}
::ng-deep.develop-is .card-body__ipwrap h2 input {
  opacity: 0;
  position: absolute;
}
::ng-deep.develop-is .card-body__ipwrap h2 input + span {
  position: relative;
  top: -2px;
  margin: 0 10px 0 0;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  text-align: center;
}
::ng-deep.develop-is .card-body__ipwrap h2 input + span::before {
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.develop-is .card-body__ipwrap h2 input:checked + span {
  background-color: #5D9CEC;
  border-color: #5D9CEC;
}
::ng-deep.develop-is .card-body__ipwrap h2 input:checked + span::before {
  opacity: 1;
}
::ng-deep.develop-is .card-body__ipwrap ul {
  padding: 0;
  margin: 0;
}
::ng-deep.develop-is .card-body__ipwrap ul li {
  list-style: none;
  padding: 0;
  width: 100%;
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__edit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__edit .form-control {
  height: 45px;
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__edit > i {
  margin-left: auto;
  cursor: pointer;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-body__ipwrap ul li:last-child .card-body__edit input {
  width: calc(100% - 30px);
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__ipinner {
  display: block;
  font-size: 15px;
  position: relative;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}
::ng-deep.develop-is .compare-sol {
  width: 49%;
  float: left;
}
::ng-deep.develop-is .fullwidth {
  width: 100%;
  display: block;
}
::ng-deep.develop-is .card_solution b {
  font-size: 15px;
}
::ng-deep.develop-is .card_solution .solution-list {
  margin-bottom: 10px;
  width: 100%;
  margin-top: 10px;
}
::ng-deep.develop-is .card_solution .solution-list span {
  display: block;
}
::ng-deep.develop-is .card_solution .solution-list__selection1 {
  margin-top: 10px;
}
::ng-deep.develop-is .card_solution .solution-list__selection2 {
  margin-left: 20px;
}

.develop-is .card-body__ipwrap ul li {
  position: relative;
}
.develop-is .card-body__ipwrap ul li input[type=checkbox] {
  position: absolute;
  top: 11px;
  left: 10px;
  z-index: 2;
}
.develop-is .card-body__ipwrap ul li input[type=checkbox] + label {
  padding-left: 31px;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -550px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup--videoexist {
  max-width: 735px;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(105, 190, 40);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(105, 190, 40);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(105, 190, 40);
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(105, 190, 40);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  position: relative;
  color: rgb(105, 190, 40);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(105, 190, 40);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(105, 190, 40);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}

.prevnext {
  padding: 20px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(105, 190, 40);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

.playbtn {
  position: absolute;
  right: 8px;
  bottom: 7px;
}
.playbtn i {
  color: #7bbc43;
}

.ideate-is .info .card__toprow .card__topcol.card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}

.card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
.card__toprow .card__topcol {
  padding: 0 15px;
}
.card__toprow .card__topcol.card__topcol--tt {
  margin-left: auto;
  text-align: right;
}
.card__toprow .card__topcol.card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}
.card__toprow .card__topcol.card__topcol--tt span {
  position: absolute;
  right: -17px;
  bottom: 18px;
}
@media only screen and (max-width: 767px) {
  .card__toprow .card__topcol.card__topcol--tt span {
    right: 2px;
  }
}

.stick-challenge {
  position: relative;
}
.stick-challenge .card-body__backouter {
  min-height: auto;
  overflow-y: auto;
  z-index: 9;
  position: relative;
}
.stick-challenge .card-body__backouter .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
.stick-challenge .card-body__backouter.plus {
  min-height: 400px;
}

.st0 {
  fill: #7bbc43;
  margin-right: 12px;
}

.st1 {
  fill: none;
  stroke: #7bbc43;
  stroke-miterlimit: 10;
  margin-right: 10px;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.modal-body__tr {
  column-count: 2;
  column-gap: 20px;
}
.modal-body__td {
  page-break-inside: avoid;
  break-inside: avoid;
}
.modal-body__buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}
.modal-body__buttons > button:not(:last-child) {
  margin-right: 15px;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: rgb(105, 190, 40);
  background: transparent;
  padding-left: 0;
  font-size: 13px;
  margin-left: 11px;
  margin-bottom: 2px;
  display: inline-block;
  position: absolute;
  top: 17px;
}

.card-body__pe .card-body__petop .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 6px;
  padding: 6px 8px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
.card-body__pe .card-body__petop .card__bwnh3ai:hover {
  opacity: 0.7;
}
.card-body__pe .card-body__petop .card__bwnh3ai i {
  font-size: 14px;
}

.EditmodeInputs .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 6px;
  padding: 6px 8px;
  cursor: pointer;
  color: rgb(105, 190, 40);
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
.EditmodeInputs .card__bwnh3ai:hover {
  opacity: 0.7;
}
.EditmodeInputs .card__bwnh3ai i {
  font-size: 14px;
}
.EditmodeInputs h3, .EditmodeInputs h4 {
  white-space: nowrap;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 15px;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--seagrn {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--seagrn:hover {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--white {
  background-color: #fff;
  border-color: #ddd;
  color: #6D6E71;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/develop-challenge/develop-challenge.component.scss","webpack://./src/app/components/challenges/_cn-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACvUA;EACI,oCAAA;AD0UJ;;AAjZA;EACI,oBAAA;AAoZJ;;AAjZA;EACI,mBAAA;AAoZJ;;AAhZI;EACI,iBAAA;EACA,mBAAA;AAmZR;AAjZQ;EAJJ;IAKQ,iBAAA;EAoZV;AACF;AAlZQ;EACI,gBAAA;AAoZZ;AA/YgB;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AAiZpB;AA/YoB;EALJ;IAMQ,aAAA;EAkZtB;EAhZsB;IACI,cAAA;EAkZ1B;AACF;AA/YoB;EACI,eAAA;AAiZxB;AAzYI;EACI,yBAAA;AA2YR;AAxYI;EC/BA,aAAA;EAEA,eAAA;EAMA,uBAAA;ED0BI,iBAAA;EACA,mBAAA;AAgZR;AA9YQ;EANJ;IAOQ,mBAAA;EAiZV;AACF;AA/YQ;EACI,mBAAA;AAiZZ;AA7YoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AA+YxB;AA7YwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EAgZ1B;AACF;AA9YwB;EAXJ;IAYQ,iBAAA;IACA,eAAA;EAiZ1B;AACF;AA7YwB;EACI,iCAAA;EACA,qCAAA;EACA,wCAAA;AA+Y5B;AAxYQ;EACI,gBAAA;AA0YZ;AAxYY;EAHJ;IAIQ,qBAAA;EA2Yd;AACF;AAzYY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA2YhB;AAzYgB;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AA2YpB;AAxYoB;EACI,yBAAA;AA0YxB;AAvYoB;EACI,iBAAA;AAyYxB;AAvYwB;EAHJ;IAIQ,eAAA;EA0Y1B;AACF;AAvYoB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,aAAA;EA0YtB;AACF;AAxYoB;EACI,aAAA;AA0YxB;AAvY4B;EACI,aAAA;AAyYhC;AAtY4B;EACI,aAAA;AAwYhC;AAlYgC;EACI,aAAA;AAoYpC;AAjYgC;EACI,aAAA;AAmYpC;AAxX4B;EACI,aAAA;AA0XhC;AAvX4B;EACI,aAAA;AAyXhC;AAjXQ;EACI,8BAAA;EACA,mBAAA;EACA,mBAAA;AAmXZ;AAjXY;EALJ;IAMQ,sBAAA;EAoXd;AACF;AAlXY;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;AAoXhB;AAhXgB;EACI,mCDlLJ;ACoiBhB;AA/WgB;EACI,sBAAA;EACA,WAAA;AAiXpB;AA/WoB;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;AAiXxB;AA3WgB;EADJ;IAEQ,qBAAA;EA8WlB;AACF;AAzWI;EACI,WAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA2WR;AAzWQ;EAPJ;IAQQ,kBAAA;EA4WV;AACF;AA1WQ;EACI,mCDrNI;ACikBhB;AA1WY;EACI,WAAA;AA4WhB;AAxWQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;ECzLR,mCAAA;EACA,8BAAA;ED0LQ,aAAA;EACA,eAAA;EACA,mBAAA;AA2WZ;AAzWY;EATJ;IAUQ,eAAA;EA4Wd;AACF;AA1WY;EAbJ;IAcQ,eAAA;EA6Wd;AACF;AA3WY;EACI,kBAAA;AA6WhB;AAzWY;EACI,WAAA;EACA,cAAA;AA2WhB;AAzWgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EA4WlB;AACF;AAxWQ;ECjQJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EDsPQ,eAAA;AAgXZ;AA1WoB;EACI,qBAAA;AA4WxB;AA1WwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EA6W1B;AACF;AAxWY;EACI,eAAA;EACA,qBAAA;AA0WhB;AAxWgB;EACI,sBAAA;AA0WpB;AAvWgB;EACI,UAAA;AAyWpB;AAvWoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EA0WtB;AACF;AAvWgB;EACI,UAAA;AAyWpB;AAvWoB;EAHJ;IAIQ,YAAA;EA0WtB;AACF;AAvWgB;EACI,UAAA;AAyWpB;AAvWoB;EAHJ;IAIQ,WAAA;EA0WtB;AACF;AAvWgB;EACI,UAAA;AAyWpB;AAvWoB;EAHJ;IAIQ,WAAA;EA0WtB;AACF;AAvWgB;EACI,iBAAA;EACA,iBAAA;AAyWpB;AAtWgB;ECnUZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADqqBJ;AA5WoB;EACI,kBAAA;AA8WxB;AA1WgB;EACI,UAAA;AA4WpB;AA1WoB;EACI,UAAA;AA4WxB;AAxWgB;ECpVZ,aAAA;EAEA,eAAA;EAMA,uBAAA;AD8rBJ;AA9WoB;ECxVhB,aAAA;EAEA,eAAA;EDwVoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAoXxB;AA/WoC;EACI,uBAAA;AAiXxC;AA7WwC;EADJ;IAEQ,WAAA;EAgX1C;AACF;AAzWoC;EACI,sBAAA;AA2WxC;AAvWwC;EADJ;IAEQ,YAAA;EA0W1C;AACF;AArW4B;EACI,iBAAA;AAuWhC;AAnWgC;EACI,kBAAA;AAqWpC;AAhWgC;EACI,wBDpYpB;ECqYoB,mCAAA;AAkWpC;AAhWoC;EACI,wBDxYxB;ECyYwB,yBAAA;AAkWxC;AAhWwC;EACI,yBAAA;EACA,WAAA;AAkW5C;AA3VgC;EACI,YAAA;EACA,mCAAA;EACA,wBDvZpB;ACovBhB;AA3VoC;EACI,wBD1ZxB;EC2ZwB,yBAAA;AA6VxC;AA3VwC;EACI,yBAAA;EACA,WAAA;AA6V5C;AAvV4B;EACI,kBAAA;EACA,wBDvahB;ECwagB,eAAA;EACA,iBAAA;ECnY5B,mCAAA;EACA,8BAAA;EDoY4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EC9Z5B,yBAAA;EDka4B,gBAAA;AA4VhC;AA1VgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AA4VpC;AA1VoC;EACI,uBD1bxB;ACsxBhB;AAxVgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EA2VlC;AACF;AAzVgC;EACI,aAAA;EACA,gBAAA;AA2VpC;AAvVoC;EADJ;IAEQ,aAAA;EA0VtC;AACF;AAvVgC;EACI,aAAA;AAyVpC;AAvVoC;EAHJ;IAIQ,qBAAA;EA0VtC;AACF;AAvVgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCD7dpB;EC8doB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAyVpC;AAvVoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EA0VtC;AACF;AAvVgC;EACI,wBD/epB;ECgfoB,UAAA;AAyVpC;AAtVgC;EACI,wBDpfpB;ECqfoB,yBAAA;EACA,UAAA;AAwVpC;AA/UY;EACI,mCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EC7dZ,mCAAA;EACA,8BAAA;ED8dY,wBDrgBA;ECsgBA,eAAA;EACA,gBAAA;ECvfZ,yBAAA;EDyfY,eAAA;AAoVhB;AAlVgB;EACI,mBAAA;AAoVpB;AAjVgB;EACI,mCDhhBJ;ECihBI,WAAA;AAmVpB;AAhVgB;EACI,aAAA;AAkVpB;AA9UY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAgVhB;AA9UgB;EACI,wBDhiBJ;ACg3BhB;AA7UgB;EACI,mBAAA;AA+UpB;AA5UgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBD3iBJ;EC4iBI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA8UpB;AAzUQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,wBD/jBI;EEsCZ,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;AD04BJ;AAhVY;EATJ;IAUQ,eAAA;EAmVd;AACF;AAjVY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EAoVd;AACF;AAlVY;EACI,kBAAA;AAoVhB;AA/UgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EAkVlB;AACF;AAhVgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AAkVpB;AAhVoB;EALJ;IAMQ,0BAAA;EAmVtB;AACF;AA/UY;EACI,eAAA;EACA,gBAAA;AAiVhB;AA/UgB;EACI,iBAAA;AAiVpB;AA/UoB;EACI,cAAA;EACA,gBAAA;AAiVxB;AA7UgB;EACI,iBAAA;AA+UpB;AA3UY;EACI,iBAAA;EACA,wBDvnBA;ACo8BhB;AA1UY;EACI,gBAAA;AA4UhB;AAzUY;EAGI,aAAA;AA2UhB;AAzUgB;EACI,mBAAA;AA2UpB;AAvUoB;EACI,cAAA;AAyUxB;AAnUQ;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;AAqUZ;AAnUY;EACI,wBDrpBA;AC09BhB;AAlUY;EACI,mBAAA;AAoUhB;AAjUY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBDhqBA;ECiqBA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAmUhB;AA7TI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;EACA,0BAAA;AA+TR;AA7TQ;EAVJ;IAWQ,kBAAA;IACA,gBAAA;EAgUV;AACF;AA9TQ;EACI,eAAA;EACA,mCAAA;EACA,8BAAA;EACA,wBDpsBI;ECqsBJ,SAAA;EACA,gBAAA;EACA,qBAAA;AAgUZ;AA9TY;EATJ;IAUQ,eAAA;EAiUd;AACF;AA9TQ;EACI,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,WAAA;EACA,mCDrtBI;ECstBJ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AAgUZ;AA9TY;EACI,aAAA;AAgUhB;AA3TI;;;;;;;EAOI,cAAA;EACA,gBAAA;AA6TR;AA1TI;EACI,gBAAA;AA4TR;AAzTI;EACI,gBAAA;AA2TR;AAxTI;EA6CI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AA8QR;AA5TQ;EACI,gBAAA;AA8TZ;AA5TY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA8ThB;AA3TY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA6ThB;AA3TgB;EACI,kBAAA;AA6TpB;AAzTY;EACI,gBAAA;AA2ThB;AAvTQ;EACI,gBAAA;AAyTZ;AAtTQ;EACI,SAAA;EACA,mCAAA;EACA,kBAAA;AAwTZ;AAtTY;EACI,6BAAA;EACA,4BAAA;AAwThB;AA9SQ;EACI,kBAAA;AAgTZ;AA9SY;EAHJ;IAIQ,kBAAA;EAiTd;AACF;AA9SQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AAgTZ;AA9SY;EACI,YAAA;AAgThB;AA9SgB;EACI,qBAAA;AAgTpB;AA7SgB;EACI,8BAAA;EACA,gBAAA;AA+SpB;AA3SY;EACI,cAAA;AA6ShB;AAzSgB;EACI,eAAA;EACA,gBAAA;AA2SpB;AAzSoB;EAJJ;IAKQ,eAAA;EA4StB;AACF;AA1SoB;EACI,gBAAA;AA4SxB;AAxSgB;ECx1BZ,aAAA;EAEA,eAAA;EDy1BgB,eAAA;AA6SpB;AA3SoB;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AA6SxB;AA3SwB;EALJ;IAMQ,WAAA;EA8S1B;AACF;AA5SwB;EACI,kBAAA;EACA,kBAAA;AA8S5B;AA5S4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AA8ShC;AAxSgB;EACI,cAAA;EACA,eAAA;AA0SpB;AAxSoB;EAJJ;IAKQ,eAAA;EA2StB;AACF;AAzSoB;EAEI,wBAAA;EACA,mBAAA;AA2SxB;AAvSgB;EACI,eAAA;AAySpB;AAvSoB;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AAySxB;AAvSwB;EALJ;IAMQ,WAAA;EA0S1B;AACF;AAxSwB;EACI,kBAAA;EACA,kBAAA;AA0S5B;AAxS4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AA0ShC;AAjSgB;EACI,kBAAA;AAmSpB;AA/RY;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AAiShB;AA/RgB;EACI,kBAAA;AAiSpB;AA9RgB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAgSpB;AA9RoB;EACI,WAAA;AAgSxB;AA3RgB;EACI,eAAA;AA6RpB;AA1RgB;EACI,gBAAA;AA4RpB;AAzRgB;EACI,cAAA;EACA,eAAA;AA2RpB;AAzRoB;EACI,iBAAA;AA2RxB;AApRoB;EACI,kBAAA;AAsRxB;AAlRgB;EACI,gBAAA;AAoRpB;AAlRoB;EACI,eAAA;AAoRxB;AAhRgB;EACI,gBAAA;AAkRpB;AA9QY;EACI,mBAAA;AAgRhB;AA9QgB;EACI,WAAA;AAgRpB;AA7QgB;;EAEI,yBAAA;EACA,mBAAA;EACA,UAAA;AA+QpB;AAxQY;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA0QhB;AAxQgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AA0QpB;AAvQgB;EACI,sBAAA;AAyQpB;AArQY;EACI,UAAA;EACA,SAAA;EACA,aAAA;AAuQhB;AArQgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAuQpB;AArQoB;EACI,kBAAA;EACA,uBD/hCR;ECgiCQ,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAuQxB;AAlQoB;EACI,8BD5iCR;ACgzChB;AAjQoB;EACI,UAAA;AAmQxB;AA7PQ;EACI,aAAA;AA+PZ;AA5PgB;EACI,cAAA;AA8PpB;AA1PY;EACI,YAAA;AA4PhB;AAzPY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA2PhB;AAzPgB;EAXJ;IAYQ,eAAA;EA4PlB;AACF;AA1PgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AA4PpB;AAzPgB;EACI,sBAAA;AA2PpB;AAvPY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AAyPhB;AAvPgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAyPpB;AAvPoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAyPxB;AApPoB;EACI,+BD3nCR;EC4nCQ,mCD5nCR;ACk3ChB;AAnPoB;EACI,UAAA;AAqPxB;AA/OQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AAiPZ;AA/OY;EACI,SAAA;EChpCZ,aAAA;EAEA,eAAA;EAYA,mBAAA;AD23CJ;AArPgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ECpoChB,yBAAA;AD83CJ;AAvPoB;EACI,iBAAA;AAyPxB;AAtPoB;EACI,iBAAA;EACA,gBAAA;AAwPxB;AApPgB;EACI,iBAAA;AAsPpB;AAnPgB;EACI,mCDtqCJ;ECuqCI,+BDvqCJ;ECwqCI,WAAA;AAqPpB;AAnPoB;EACI,mCD3qCR;EC4qCQ,mCAAA;AAqPxB;AAjPgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AAmPpB;AAjPoB;EACI,yBAAA;EACA,qBAAA;AAmPxB;AA9OoB;EACI,SAAA;AAgPxB;AA5OgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ECxrChB,yBAAA;ADy6CJ;AA9OoB;EACI,kBAAA;EACA,UAAA;EC7rCpB,yBAAA;ADg7CJ;AA/OoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAiPxB;AA/OwB;EANJ;IAOQ,kBAAA;IACA,iBAAA;EAkP1B;AACF;AAhPwB;EACI,kBAAA;EACA,OAAA;AAkP5B;AA/OwB;EACI,iBAAA;AAiP5B;AA7OoB;EACI,cAAA;EACA,eAAA;ECxtCpB,yBAAA;AD08CJ;AA3OQ;EACI,gBAAA;AA6OZ;AA3OY;EACI,cAAA;ECvvCZ,aAAA;EAEA,eAAA;EAYA,mBAAA;AD89CJ;AAjPgB;EACI,cAAA;AAmPpB;AAjPoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EAoPtB;EAlPsB;IACI,gBAAA;EAoP1B;AACF;AAhPwB;EACI,iBAAA;AAkP5B;AA7OgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AA+OpB;AA7OoB;EAVJ;IAWQ,eAAA;EAgPtB;AACF;AA9OoB;EACI,iBAAA;EACA,gBAAA;AAgPxB;AA7OoB;EACI,mCD9xCR;EC+xCQ,WAAA;EACA,gBAAA;AA+OxB;AA5OoB;EACI,YAAA;AA8OxB;AA3OoB;EACI,UAAA;EACA,6BAAA;EACA,cD9xCH;EC+xCG,wEDl0CX;ECm0CW,eAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AA6OxB;AA3OwB;EACI,WAAA;AA6O5B;AAzOoB;EACI,+BDvzCR;ACkiDhB;AAxOoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AA0OxB;AAvOoB;EACI,cAAA;AAyOxB;AAtOoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EC3zCpB,yBAAA;ADsiDJ;AAxOwB;EACI,eAAA;EACA,cDp0CP;AC8iDrB;AAvOwB;EACI,kBAAA;EACA,UAAA;ECr0CxB,yBAAA;EDu0CwB,gBAAA;AA2O5B;AAxOwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA0O5B;AAxO4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EA2O9B;AACF;AAzO4B;EACI,kBAAA;EACA,OAAA;AA2OhC;AAxO4B;EACI,iBAAA;AA0OhC;AAtOwB;EA3CJ;IA4CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EAyO1B;AACF;AAxO4B;EAjDR;IAkDY,kBAAA;IACA,iBAAA;EA2O9B;AACF;AApPwB;EAWI;IACI,kBAAA;IACA,OAAA;EA4O9B;EAzO0B;IACI,4BAAA;EA2O9B;AACF;AAxOwB;EACI,cAAA;EACA,eAAA;ECt3CxB,yBAAA;ADmmDJ;AArOQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AAuOZ;AArOY;EACI,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;AAuOhB;AAnOQ;EACI,sBAAA;AAqOZ;AAnOY;EACI,kBAAA;AAqOhB;AAjOQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;AAmOZ;AAjOY;EACI,uBD56CA;AC+oDhB;AA/NQ;EACI,uBDj7CI;ACkpDhB;AA9NQ;EACI,eAAA;AAgOZ;AA9NY;EACI,gBAAA;AAgOhB;AA5NQ;EACI,kBAAA;AA8NZ;AA5NY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AA8NhB;AA5NgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAgOpB;AA9NoB;EARJ;;;;IASQ,eAAA;EAoOtB;AACF;AA/NoB;;EACI,aAAA;AAkOxB;AA7NY;EACI,eAAA;EC79CZ,aAAA;EAEA,eAAA;AD+rDJ;AAjOgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAmOpB;AAjOoB;EACI,aAAA;AAmOxB;AAhOoB;EACI,UAAA;AAkOxB;AA/NoB;EACI,kBAAA;AAiOxB;AA7NgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;AA+NpB;AA5NgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA8NpB;AA5NoB;EAEI,aAAA;AA6NxB;AAzNgB;;EC1gDZ,aAAA;EAEA,eAAA;ADyuDJ;AA7NoB;;EACI,WAAA;EC/gDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EDogDoB,uBAAA;EACA,kBAAA;AAsOxB;AApOwB;;EACI,gBAAA;AAuO5B;AAnOoB;;EACI,WAAA;EACA,kBAAA;EC5hDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;EDwhDoB,eAAA;EACA,0BAAA;AA8OxB;AA5OwB;;EACI,wBAAA;EACA,mBAAA;AA+O5B;AA3OgC;;;EAEI,aAAA;AA8OpC;AAzOwB;;EACI,gBAAA;EACA,gBAAA;AA4O5B;AAxOoB;;EAEI,YAAA;EACA,mBAAA;AA0OxB;AAxOwB;;EACI,YAAA;AA2O5B;AAtO4B;;EACI,0BD9jDhB;ACuyDhB;AApOwB;EAjBJ;;IAkBQ,WAAA;IACA,gBAAA;IACA,mBAAA;EAwO1B;AACF;AArOoB;;EAEI,yBAAA;EACA,mBAAA;AAuOxB;AArOwB;;EACI,yBAAA;AAwO5B;AArOwB;;EACI,kBAAA;AAwO5B;AAtO4B;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,wBD5lDhB;ACq0DhB;AAvOgC;;;EAEI,cAAA;AA0OpC;AAvOgC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AA0OpC;AAtO4B;;EACI,kBAAA;AAyOhC;AAvOgC;;;EAEI,aAAA;AA0OpC;AApOwB;;EACI,mBAAA;AAuO5B;AArO4B;;;EAEI,aAAA;AAwOhC;AApOwB;EA5DJ;;IA6DQ,WAAA;EAwO1B;AACF;AApO4B;EADJ;;IAEQ,SAAA;IACA,uBAAA;IACA,WAAA;EAwO9B;AACF;AApOoB;;EACI,WAAA;AAuOxB;AAhOgB;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cDxpDC;EEIjB,yBAAA;ADy3DJ;AAlOoB;EACI,mCDxqDR;ECyqDQ,mCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAoOxB;AA9NQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AAgOZ;AA9NY;EACI,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;AAgOhB;AA5NQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,QAAA;EAGA,2BAAA;ECjsDR,yBAAA;ADk6DJ;AA9NY;EACI,mCDrtDA;ECstDA,+BDttDA;ECutDA,WAAA;AAgOhB;AA5NQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;AA8NZ;AA5NY;EACI,UAAA;AA8NhB;AA5NgB;EACI,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AA8NpB;AA1NoB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AA2NxB;AAxNoB;EACI,WAAA;EACA,UAAA;AA0NxB;AAjNgB;EACI,WAAA;AAmNpB;AA/MY;EACI,gCAAA;EACA,mBAAA;AAiNhB;AA9MY;EACI,kBAAA;EACA,kBAAA;AAgNhB;AA9MgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAgNpB;AA3MQ;ECjyDJ,aAAA;EAEA,eAAA;EDiyDQ,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAiNZ;AA/MY;EACI,UAAA;AAiNhB;AA7MgB;EACI,WAAA;AA+MpB;AA3MoB;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AA6MxB;AA3MwB;EALJ;IAMQ,0BAAA;EA8M1B;AACF;AA1M4B;EACI,YAAA;AA4MhC;AAxMwB;EACI,0BAAA;AA0M5B;AArM4B;EACI,aAAA;AAuMhC;AAjM4B;EACI,aAAA;AAmMhC;AA7L4B;EACI,aAAA;AA+LhC;AAzL4B;EACI,aAAA;AA2LhC;AArL4B;EACI,aAAA;AAuLhC;AAhLgB;EACI,WAAA;AAkLpB;AA9KwB;EACI,gBAAA;AAgL5B;AA7KwB;EACI,WAAA;AA+K5B;AAxKoB;EC93DhB,aAAA;EAEA,eAAA;ED83DoB,8BAAA;EACA,eAAA;AA8KxB;AA5KwB;EACI,OAAA;EACA,cAAA;AA8K5B;AA5K4B;EAJJ;IAKQ,UAAA;IACA,WAAA;EA+K9B;EA7K8B;IACI,gBAAA;EA+KlC;AACF;AA5K4B;EACI,eAAA;EACA,cAAA;AA8KhC;AAxKgB;EACI,yBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAyKpB;AAvKoB;EACI,kBAAA;AAyKxB;AAvKwB;;EAEI,kBAAA;EACA,wBDj6DZ;ECk6DY,eAAA;EACA,mBAAA;AAyK5B;AAtKgC;;EACI,eAAA;EACA,gBAAA;EACA,wBDz6DpB;ACklEhB;AAnK4B;EACI,cAAA;AAqKhC;AAlKoC;EACI,cAAA;AAoKxC;AA9JwB;EACI,gBAAA;AAgK5B;AA7JwB;EACI,kBAAA;AA+J5B;AAzJoC;EACI,uBAAA;EACA,eAAA;AA2JxC;AAtJ4B;EACI,kBAAA;EACA,aAAA;EACA,WAAA;AAwJhC;AAtJgC;EACI,yBAAA;EACA,eAAA;AAwJpC;AAnJgC;EACI,eAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AAqJpC;AAnJoC;EACI,WAAA;EACA,yBAAA;AAqJxC;AA3IoB;EAEI,aAAA;AA4IxB;AAtIQ;EACI,aAAA;AAwIZ;AAtIY;EACI,sBAAA;AAwIhB;AArIY;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AAuIhB;AApIY;EACI,aAAA;EACA,kBAAA;AAsIhB;AApIgB;EAJJ;IAKQ,kBAAA;EAuIlB;AACF;AAhIY;EACI,sBAAA;AAkIhB;AAtHY;EACI,UAAA;AAwHhB;AArHY;EACI,kBAAA;AAuHhB;AArHgB;EAHJ;IAIQ,kBAAA;EAwHlB;AACF;AApHY;EACI,gCAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAsHhB;AA/GgB;EACI,aAAA;AAiHpB;AA/GoB;EAHJ;IAIQ,cAAA;EAkHtB;AACF;AA/GgB;EACI,kBAAA;AAiHpB;AA/GoB;EAHJ;IAIQ,aAAA;EAkHtB;AACF;AAhHoB;EACI,gBAAA;AAkHxB;AA/GoB;EACI,gBAAA;AAiHxB;AA7GgB;EACI,gBAAA;EACA,kBAAA;AA+GpB;AA5GgB;EAxCJ;IAyCQ,mBAAA;IACA,kBAAA;EA+GlB;AACF;AA3GY;EACI,mBAAA;AA6GhB;AA3GgB;EACI,UAAA;AA6GpB;AA1GgB;EACI,eAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AA4GpB;AA1GoB;EAPJ;IAQQ,eAAA;EA6GtB;AACF;AA3GoB;EAXJ;IAYQ,eAAA;IACA,kBAAA;IACA,sBAAA;IACA,mBAAA;EA8GtB;AACF;AA5GoB;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AA8GxB;AA5GwB;EACI,YAAA;AA8G5B;AA3GwB;EACI,eAAA;AA6G5B;AAzGoB;EACI,sBAAA;EACA,wBD1oER;EC2oEQ,wBAAA;EACA,gBAAA;AA2GxB;AAzGwB;EANJ;IAOQ,WAAA;IACA,YAAA;IACA,eAAA;EA4G1B;AACF;AAxGgB;EACI,mCDvpEJ;ECwpEI,kBAAA;AA0GpB;AAtGwB;EACI,WAAA;EACA,eAAA;AAwG5B;AApFwC;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBDtrE5B;AC4wEhB;AApF4C;EANJ;IAOQ,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;EAuF9C;AACF;AApFgD;EACI,UAAA;AAsFpD;AA9EgC;EACI,kBAAA;AAgFpC;AA5E4C;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;AA8EhD;AAxEgD;EACI,uBAAA;AA0EpD;AAlEgD;EACI,cAAA;AAoEpD;AAzDgC;EACI,YAAA;AA2DpC;AAvDoC;EACI,uBAAA;AAyDxC;AApDoC;EACI,uBAAA;AAsDxC;AAjDoC;EACI,uBAAA;AAmDxC;AA/CgC;EACI,uBAAA;EACA,kBAAA;AAiDpC;AA/CoC;EACI,aAAA;AAiDxC;AAtCI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AAwCR;AAtCQ;EACI,UAAA;EACA,mBAAA;AAwCZ;AApCI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AAsCR;AApCQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AAsCZ;AApCY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AAsChB;AApCgB;EACI,kBAAA;EACA,WAAA;AAsCpB;AApCoB;EACI,uBAAA;EACA,+BDv0ER;ECw0EQ,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AAsCxB;AAlCgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AAoCpB;AA9BI;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;ECv2EJ,aAAA;EAEA,eAAA;EDu2EI,WAAA;AAoCR;AAlCQ;EACI,YAAA;EACA,gBAAA;AAoCZ;AAlCY;EACI,uBAAA;EACA,UAAA;AAoChB;AAlCgB;EACI,0BAAA;AAoCpB;AAhCY;EACI,uBAAA;EACA,UAAA;AAkChB;AAhCgB;EACI,0BAAA;AAkCpB;AA9BY;EACI,uBAAA;EACA,UAAA;AAgChB;AA9BgB;EACI,0BAAA;AAgCpB;AA5BY;EACI,uBAAA;EACA,UAAA;AA8BhB;AA5BgB;EACI,0BAAA;AA8BpB;AA3BgB;EACI,gBAAA;AA6BpB;AA3BoB;EACI,gBAAA;AA6BxB;AAvBQ;EACI,mBAAA;AAyBZ;AAvBY;EC/5ER,aAAA;EAEA,eAAA;AD27EJ;AA3BgB;EACI,eAAA;AA6BpB;AA3BoB;EACI,sBAAA;AA6BxB;AA1BoB;EACI,UAAA;AA4BxB;AA1BwB;EAHJ;IAIQ,OAAA;EA6B1B;AACF;AA1BoB;EACI,UAAA;AA4BxB;AA1BwB;EAHJ;IAIQ,YAAA;EA6B1B;AACF;AA1BoB;EACI,UAAA;EACA,iBAAA;AA4BxB;AA1BwB;EAJJ;IAKQ,WAAA;EA6B1B;AACF;AAxBoB;ECp8EhB,aAAA;EAEA,eAAA;EAYA,mBAAA;ADw9EJ;AA9BwB;EACI,YAAA;EACA,mBAAA;AAgC5B;AA9B4B;EAJJ;IAKQ,WAAA;IACA,kBAAA;EAiC9B;AACF;AA9BwB;EACI,yBAAA;AAgC5B;AA7BwB;EACI,mCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;ECh7ExB,mCAAA;EACA,8BAAA;EDi7EwB,wBDx9EZ;ECy9EY,eAAA;EACA,yBAAA;EACA,eAAA;AAgC5B;AA9B4B;EACI,mCD99EhB;EC+9EgB,WAAA;AAgChC;AA7B4B;EACI,aAAA;AA+BhC;AA1BoB;EACI,UAAA;AA4BxB;AAzBoB;ECh/EhB,aAAA;EAEA,eAAA;EAMA,uBAAA;AD2gFJ;AA/BwB;ECp/EpB,aAAA;EAEA,eAAA;EDo/EwB,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAqC5B;AAnC4B;EACI,gBAAA;AAqChC;AAjCwC;EACI,uBAAA;AAmC5C;AA/B4C;EADJ;IAEQ,WAAA;EAkC9C;AACF;AA3BwC;EACI,sBAAA;AA6B5C;AAzB4C;EADJ;IAEQ,YAAA;EA4B9C;AACF;AAtBoC;EACI,kBAAA;AAwBxC;AAnBoC;EACI,wBD9hFxB;EC+hFwB,mCAAA;AAqBxC;AAnBwC;EACI,wBDliF5B;ECmiF4B,yBAAA;AAqB5C;AAnB4C;EACI,yBAAA;EACA,WAAA;AAqBhD;AAdoC;EACI,YAAA;EACA,mCAAA;EACA,wBDjjFxB;ACikFhB;AAdwC;EACI,wBDpjF5B;ECqjF4B,yBAAA;AAgB5C;AAd4C;EACI,yBAAA;EACA,WAAA;AAgBhD;AAVgC;EACI,kBAAA;EACA,wBDjkFpB;ECkkFoB,eAAA;EACA,iBAAA;EC7hFhC,mCAAA;EACA,8BAAA;ED8hFgC,qBAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EC3jFhC,yBAAA;ED+jFgC,gBAAA;AAepC;AAboC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AAexC;AAbwC;EACI,uBDvlF5B;ACsmFhB;AAXoC;EA5BJ;IA6BQ,cAAA;IACA,oBAAA;IACA,QAAA;IACA,YAAA;IACA,gBAAA;EActC;AACF;AAZoC;EApCJ;IAqCQ,gBAAA;EAetC;AACF;AAboC;EACI,aAAA;EACA,gBAAA;AAexC;AAXwC;EADJ;IAEQ,aAAA;EAc1C;AACF;AAXoC;EACI,aAAA;AAaxC;AAXwC;EAHJ;IAIQ,qBAAA;EAc1C;AACF;AAVoC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCDloFxB;ECmoFwB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAYxC;AAVwC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAa1C;AACF;AAVoC;EACI,wBDppFxB;ECqpFwB,UAAA;AAYxC;AAToC;EACI,wBDzpFxB;EC0pFwB,yBAAA;EACA,UAAA;AAWxC;AAJoB;EACI,iBAAA;AAMxB;AAJwB;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAM5B;AAJ4B;EACI,cAAA;AAMhC;AACgB;EACI,gBAAA;AACpB;AAEgB;EACI,qBAAA;AAApB;AAOQ;EACI,aAAA;AALZ;AAOY;EAHJ;IAIQ,WAAA;EAJd;AACF;AAOQ;EACI,gCAAA;AALZ;AAOY;EACI,YAAA;AALhB;AASQ;EACI,gCAAA;AAPZ;AASY;EACI,YAAA;AAPhB;AAWQ;EACI,gCAAA;AATZ;AAWY;EACI,YAAA;AAThB;AAcY;EACI,aAAA;AAZhB;AAmBQ;EACI,kBAAA;EACA,kBAAA;EACA,wBD3uFI;EC4uFJ,eAAA;EACA,aAAA;EACA,oCAAA;AAjBZ;AAmBY;EARJ;IASQ,kBAAA;EAhBd;AACF;AAkBY;EACI,WAAA;EACA,6BDtvFA;ECuvFA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAGA,aAAA;EAGA,uBAAA;EAGA,mBAAA;AAhBhB;AAkBgB;EArBJ;IAsBQ,WAAA;IACA,YAAA;EAflB;AACF;AAkBY;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAhBhB;AAoBQ;EACI,WAAA;EACA,WAAA;EACA,eAAA;AAlBZ;AAsBY;EACI,eAAA;EACA,wBDlyFA;ECmyFA,eAAA;AApBhB;AAsBgB;EACI,kBAAA;AApBpB;AAyBQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AAvBZ;AAyBY;EACI,qBAAA;EACA,eAAA;AAvBhB;AA0BY;EACI,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAxBhB;AA6BY;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA3BhB;AA6BgB;EACI,gBAAA;AA3BpB;AA8BgB;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EAGA,2BAAA;AA5BpB;AAgCY;EACI,qBAAA;EACA,eAAA;AA9BhB;AAiCY;;EAEI,YAAA;EACA,kBAAA;EACA,aAAA;AA/BhB;AAkCY;EACI,qBAAA;EACA,wBAAA;AAhChB;AAmCY;EACI,YAAA;EACA,kBAAA;AAjChB;AAsCI;EACI,wBD72FQ;ACy0FhB;AAwCQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;AAtCZ;AAwCY;EACI,YAAA;AAtChB;AAyCY;EACI,gBAAA;AAvChB;AA0CY;EACI,kCDr4FA;AC61FhB;AA2CY;EACI,kCDx4FD;AC+1Ff;AA4CY;EACI,kCD14FE;ACg2FlB;AA+CI;EACI,kBAAA;AA7CR;AA+CQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AA7CZ;AA+CY;EACI,QAAA;AA7ChB;AA+CgB;EACI,eAAA;EACA,WAAA;EAGA,8BAAA;AA7CpB;AAiDY;EACI,WAAA;EACA,SAAA;AA/ChB;AAiDgB;EACI,eAAA;EAIA,sBAAA;EAGA,8BAAA;EACA,YAAA;EACA,WAAA;EAGA,mBAAA;AA/CpB;AAmDY;EACI,mBAAA;EAGA,aAAA;EAEA,eAAA;AAjDhB;AAmDgB;EACI,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAjDpB;AAqDY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AAnDhB;AAqDgB;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EAGA,yBAAA;AAnDpB;AAqDoB;EAGI,yBAAA;AAnDxB;AAuDgB;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AArDpB;AAuDoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AArDxB;AAuDwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AArD5B;AA0DgB;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAxDpB;AA2DgB;EACI,SAAA;AAzDpB;AA2DoB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAzDxB;AA2DwB;EACI,uCAAA;AAzD5B;AAiEI;EACI,gBAAA;EACA,8BAAA;EACA,4BAAA;AA/DR;AAkEI;EACI,oBAAA;EACA,oBAAA;EAGA,aAAA;EAEA,eAAA;AAhER;AAkEQ;EACI,gBAAA;EACA,4BAAA;AAhEZ;AAmEQ;EACI,oBAAA;EACA,UAAA;AAjEZ;AAoEQ;EACI,+BAAA;EAEA,iBAAA;EACA,gBAAA;AAlEZ;AAqEgB;EACI,kBAAA;AAnEpB;AAwEQ;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EAGA,eAAA;AAtEZ;AAwEY;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;AAtEhB;AAwEgB;EACI,aAAA;AAtEpB;AAwEoB;EACI,kBAAA;AAtExB;AAwEwB;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAtE5B;AA2EgB;EACI,YAAA;AAzEpB;AAuFQ;EACI,iBAAA;AArFZ;AAwFQ;EACI,eAAA;EACA,mBAAA;EACA,UAAA;AAtFZ;AAwFY;EALJ;IAMQ,UAAA;EArFd;AACF;AAuFY;EATJ;IAUQ,WAAA;EApFd;AACF;AAsFY;EAGI,aAAA;EAEA,eAAA;AApFhB;AAsFgB;EACI,wBAAA;AApFpB;AAuFgB;EACI,WAAA;AArFpB;AAuFoB;EACI,yBAAA;EACA,4BAAA;AArFxB;AA0FY;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAxFhB;AA0FgB;EACI,mBAAA;AAxFpB;AA2FgB;EACI,iBAAA;AAzFpB;AA4FgB;EAjBJ;IAkBQ,UAAA;EAzFlB;AACF;AA2FgB;EArBJ;IAsBQ,WAAA;EAxFlB;AACF;AA0FgB;EACI,eAAA;AAxFpB;AA6FQ;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA3FZ;AA6FY;EACI,qBAAA;AA3FhB;AA8FY;EACI,UAAA;EACA,kBAAA;AA5FhB;AA8FgB;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AA5FpB;AA8FoB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AA5FxB;AAgGgB;EACI,yBAAA;EACA,qBAAA;AA9FpB;AAiGgB;EACI,UAAA;AA/FpB;AAoGQ;EACI,UAAA;EACA,SAAA;AAlGZ;AAoGY;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AAlGhB;AAoGgB;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;AAlGpB;AAoGoB;EACI,YAAA;AAlGxB;AAqGoB;EACI,iBAAA;EACA,eAAA;EACA,wBDnwGR;ACgqGhB;AAyGwB;EACI,wBAAA;AAvG5B;AA4GgB;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AA1GpB;AAgHI;EACI,UAAA;EACA,WAAA;AA9GR;AAiHI;EACI,WAAA;EACA,cAAA;AA/GR;AAmHQ;EACI,eAAA;AAjHZ;AAoHQ;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;AAlHZ;AAoHY;EACI,cAAA;AAlHhB;AAqHY;EACI,gBAAA;AAnHhB;AAsHY;EACI,iBAAA;AApHhB;;AA2HA;EACI,kBAAA;AAxHJ;AA0HI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAxHR;AA0HQ;EACI,kBAAA;AAxHZ;;AA6HA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;ECz0GA,yBAAA;ED20GA,gBAAA;AAxHJ;AA0HI;EACI,QAAA;AAxHR;AA2HI;EACI,gBAAA;AAzHR;AA4HI;ECz2GA,aAAA;EAEA,eAAA;EDy2GI,UAAA;EACA,gBAAA;AAtHR;AAwHQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAtHZ;AAwHY;EACI,WAAA;EACA,wBDl3GA;ECm3GA,eAAA;EACA,iBAAA;EC90GZ,mCAAA;EACA,8BAAA;ED+0GY,qBAAA;EACA,YAAA;EACA,SAAA;EACA,mCAAA;EACA,6BAAA;EACA,yBAAA;EC/1GZ,gBAAA;AD6uGJ;AAqHgB;EACI,aAAA;AAnHpB;AAsHgB;EACI,YAAA;AApHpB;AAsHoB;EACI,UAAA;AApHxB;AAwHgB;EACI,UAAA;AAtHpB;AAyHgB;EACI,kBAAA;EACA,UAAA;AAvHpB;AA2HY;EACI,iBAAA;AAzHhB;AA6HgB;EACI,0BAAA;AA3HpB;AAgIgB;EACI,0BAAA;AA9HpB;AAoII;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAlIR;AAqII;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAnIR;AAsII;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EC16GJ,yBAAA;ADyyGJ;AAoIQ;EAGI,yBAAA;AAlIZ;AAqIQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AAnIZ;AAqIY;EACI,kBAAA;EACA,mBAAA;AAnIhB;AAqIgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AAnIpB;AAsIgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AApIpB;AA0II;EACI,gBAAA;AAxIR;AA2IY;EACI,gBAAA;EACA,mBAAA;AAzIhB;AA2IgB;EACI,gBAAA;EACA,yBAAA;AAzIpB;AA2IoB;;EAEI,yBAAA;EACA,gBAAA;AAzIxB;AA6IgB;EACI,gBAAA;AA3IpB;AAgJgB;EACI,uBD9/GJ;ACg3GhB;AAmJgB;EACI,uBDngHL;ACk3Gf;AAsJgB;EACI,wBDxgHJ;ACo3GhB;AAyJgB;EACI,uBD7gHF;ACs3GlB;AA2JY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EC/+GZ,mCAAA;EACA,8BAAA;ADu1GJ;AA0JgB;EACI,eAAA;AAxJpB;AA4JY;EACI,kBAAA;EACA,gBAAA;AA1JhB;AA4JgB;EACI,gBAAA;AA1JpB;AA8JY;EACI,gBAAA;AA5JhB;AAiKI;EACI,UAAA;EACA,SAAA;AA/JR;AAiKQ;EACI,gBAAA;EACA,WAAA;AA/JZ;AAiKY;EACI,kBAAA;EACA,wBDtjHA;EEgBZ,yBAAA;AD04GJ;AAiKgB;EACI,aAAA;AA/JpB;AAmKY;EACI,eAAA;AAjKhB;;AA4KQ;EACI,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;ECrlHR,aAAA;EAEA,eAAA;AD+6GJ;AAuKY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AArKhB;AAwKY;EC9lHR,aAAA;EAEA,eAAA;ED8lHY,SAAA;EACA,kBAAA;EACA,wBD9lHA;EC+lHA,kBAAA;ECzjHZ,mCAAA;EACA,8BAAA;ADw5GJ;AAmKgB;ECllHZ,yBAAA;ADo7GJ;AAoKQ;EACI,mCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AAlKZ;AAoKY;EACI,aAAA;AAlKhB;AAoKgB;EACI,gBAAA;AAlKpB;AAqKgB;EACI,gBAAA;EACA,kBAAA;EACA,wBDxnHJ;EEsCZ,mCAAA;EACA,8BAAA;ADg7GJ;AAqKgB;EACI,SAAA;EACA,UAAA;AAnKpB;AAqKoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAnKxB;AAqKwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAnK5B;AAsKwB;EACI,eAAA;AApK5B;AA2KQ;EACI,gBAAA;AAzKZ;AA6KY;EACI,0BAAA;AA3KhB;AA6KgB;EChoHZ,wBAAA;ADw9GJ;AA+KY;EACI,cAAA;AA7KhB;;AAsLA;EACI,eAAA;AAnLJ;AAqLI;EC1rHA,aAAA;EAEA,eAAA;EAYA,mBAAA;ED+qHI,UAAA;EACA,SAAA;AA7KR;AAgLI;EACI,gBAAA;AA9KR;AAgLQ;EACI,iBAAA;AA9KZ;AAkLY;EACI,UAAA;AAhLhB;AAoLQ;EACI,mCD3sHI;EC4sHJ,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAlLZ;AAoLY;EACI,SAAA;AAlLhB;AAsLQ;EChrHJ,mCAAA;EACA,8BAAA;EDirHQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EC5sHR,yBAAA;AD4hHJ;AAmLY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;ECltHZ,yBAAA;ADoiHJ;;AAqLA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AAlLJ;AAoLI;EACI,cAAA;AAlLR;;AAsLA;EACI,eAAA;EACA,eAAA;AAnLJ;;AAsLA;EC5vHI,aAAA;EAEA,eAAA;EAYA,mBAAA;EDivHA,eAAA;AA7KJ;AA+KI;EACI,eAAA;AA7KR;AAgLQ;EACI,iBAAA;EACA,iBAAA;AA9KZ;AAgLY;EACI,eAAA;EACA,eAAA;AA9KhB;AAiLY;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AA/KhB;AAiLgB;EALJ;IAMQ,UAAA;EA9KlB;AACF;;AAoLA;EACI,kBAAA;AAjLJ;AAmLI;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAjLR;AAmLQ;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AAjLZ;AAoLQ;EACI,iBAAA;AAlLZ;;AAsMA;EACI,aAAA;EACA,kBAAA;AAnMJ;;AAsMA;EACI,UAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AAnMJ;;AAsMA;EACI,eAAA;AAnMJ;AAqMI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AApMR;AAuMI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AArMR;;AA2MI;EACI,eAAA;EACA,gBAAA;AAxMR;AA2MI;EAEI,wBAAA;EACA,mBAAA;AAzMR;AA4MI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AA1MR;AA8MY;EACI,kBAAA;AA5MhB;;AAkNA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AA/MJ;;AAkNA;EACI,sBAAA;EACA,kBAAA;AA/MJ;;AAkNA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AA/MJ;AAiNI;EACI,wBD/5HQ;ECg6HR,uBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;AA/MR;;AAsNQ;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AAnNZ;AAqNY;EACI,YAAA;AAnNhB;AAsNY;EACI,eAAA;AApNhB;;AA2NI;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBD78HQ;EC88HR,eAAA;EACA,kBAAA;EACA,6BAAA;AAxNR;AA0NQ;EACI,YAAA;AAxNZ;AA2NQ;EACI,eAAA;AAzNZ;AA6NI;EACI,mBAAA;AA3NR;;AA+NA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AA5NJ;;AA+NA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA5NJ;;AAgOA;EACI,mCAAA;EACA,UAAA;AA7NJ;;AAgOA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AA7NJ;;AAgOA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AA7NJ;;AAgOA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AA7NJ;;AAgOA;EACI;IACI,UAAA;EA7NN;EAgOE;IACI,UAAA;EA9NN;EAiOE;IACI,UAAA;EA/NN;AACF;AAoOA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAlOJ;AAoOI;EACI,yBAAA;AAlOR;AAqOI;EACI,oCAAA;AAnOR;AAuOQ;EACI,mCAAA;AArOZ;AAwOQ;EACI,UAAA;AAtOZ;AA2OQ;EACI,0BAAA;AAzOZ;AA6OI;EACI,kBAAA;EACA,gBAAA;AA3OR;AA8OI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AA5OR;AA8OQ;EALJ;IAMQ,YAAA;IACA,iBAAA;EA3OV;AACF;AA6OQ;EACI,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AA3OZ;AA6OY;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AA3OhB;AA6OgB;EACI,aAAA;AA3OpB;AA+OY;EACI,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AA7OhB;AAoPoB;EACI,mBAAA;AAlPxB;AAyPI;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAvPR;AAyPQ;EACI,qBAAA;EACA,yBAAA;AAvPZ;AA0PQ;EACI,qBAAA;EACA,yBAAA;AAxPZ;AA0PY;EACI,qBAAA;EACA,yBAAA;AAxPhB;AA4PQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AA1PZ;AA4PY;EACI,qBAAA;EACA,yBAAA;AA1PhB;AA8PQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AA5PZ;AA8PY;EACI,qBAAA;EACA,yBAAA;AA5PhB;AAgQQ;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AA9PZ;AAiQQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AA/PZ;AAiQY;EACI,qBAAA;EACA,yBAAA;AA/PhB;;AAqQA;EACI,gBAAA;AAlQJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../cn-shared';\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.develop-is {\n    &.editmode {\n        padding: 5px 60px;\n        background: #ebebeb;\n\n        @media only screen and (max-width: 991px) {\n            padding: 40px 0 0;\n        }\n\n        .mainnav {\n            margin: 0 0 15px;\n        }\n\n        .editmode_icons {\n            .formattingIcon {\n                li {\n                    border-radius: 5px;\n                    height: 31px;\n                    margin-left: 5px;\n\n                    @media only screen and (max-width: 991px) {\n                        display: none;\n\n                        &:first-child {\n                            display: block;\n                        }\n                    }\n\n                    svg {\n                        cursor: pointer;\n                    }\n                }\n            }\n\n        }\n    }\n\n    .highlight {\n        background-color: #B4D5FF\n    }\n\n    .mainnav {\n        @include fflex();\n        @include fflex-jcc();\n        flex-wrap: nowrap;\n        margin: 30px 0 40px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 30px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media #{$mq-md} {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media #{$mq-sm} {\n                            padding: 11px 5px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &__editmodeicon {\n            margin-left: 5px;\n\n            @media #{$mq-sm} {\n                margin: 10px 0 0 auto;\n            }\n\n            ul {\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0;\n                padding: 0;\n                height: 100%;\n\n                li {\n                    list-style: none;\n                    transition: none;\n                    width: 37px;\n                    height: 100%;\n                    border-radius: 5px;\n                    background-color: #fff;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: pointer;\n                    border: 1px solid $cn-border-color;\n\n\n                    &.active {\n                        background-color: #676a6c;\n                    }\n\n                    &:not(:last-child) {\n                        margin-right: 5px;\n\n                        @media #{$mq-md} {\n                            margin-right: 0;\n                        }\n                    }\n\n                    @media #{$mq-md} {\n                        width: 35px;\n                        height: 31px;\n                        display: none;\n                    }\n\n                    &.mainnav__editmodepin {\n                        display: flex;\n\n                        svg {\n                            .st0 {\n                                fill: #FFFFFF;\n                            }\n\n                            .st1 {\n                                fill: #cfdbe2;\n                            }\n                        }\n\n                        &--pinactive {\n                            svg {\n                                .st0 {\n                                    fill: #6d6e71;\n                                }\n\n                                .st1 {\n                                    fill: #FFFFFF;\n                                }\n                            }\n                        }\n                    }\n\n                    &.listView,\n                    &.individualView,\n                    &.gridView {\n\n                        svg {\n                            .st0 {\n                                fill: #6d6e71;\n                            }\n\n                            .st1 {\n                                fill: #FFFFFF;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        &.editnav {\n            justify-content: space-between;\n            align-items: center;\n            background: #EBEBEB;\n\n            @media #{$mq-sm} {\n                flex-direction: column;\n            }\n\n            ul {\n                background-color: #ebebeb;\n                border-radius: 5px;\n                width: 100%;\n                flex: 1;\n\n\n\n                .develop.active {\n                    background-color: $develop-color;\n                }\n\n                li {\n                    background-color: #fff;\n                    width: 100%;\n\n                    a {\n                        padding: 5px 2px;\n                        width: 100%;\n                        text-align: center;\n                    }\n                }\n            }\n\n            .editmode_icons {\n                @media #{$mq-sm} {\n                    margin: 10px 0 0 auto;\n                }\n            }\n        }\n    }\n\n    .info {\n        color: #fff;\n        border: 1px solid $develop-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $develop-color;\n\n            h3 {\n                color: #fff\n            }\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &--full {\n                    width: 100% !important;\n                }\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n                }\n\n                &:nth-child(3) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n                }\n\n                &.card__topcol--tt {\n                    margin-left: auto;\n                    text-align: right;\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--startexist {\n                    width: calc(65%);\n\n                    &+div {\n                        width: calc(100% - 65%);\n                    }\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $develop-color;\n                                    border: 1px solid $develop-color;\n\n                                    span.card__topcount {\n                                        color: $develop-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $develop-color;\n                                    color: $develop-color;\n\n                                    span.card__topcount {\n                                        color: $develop-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $develop-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $develop-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $develop-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $develop-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n\n            .card__h3button {\n                border: 1px solid $develop-color;\n                background-color: transparent;\n                padding: 2px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $develop-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &.disabled {\n                    cursor: not-allowed;\n                }\n\n                &:hover {\n                    background-color: $develop-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $develop-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $develop-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $develop-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            .card__bwnh3title {\n                margin-right: 10px;\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n            a {\n                margin-left: 10px;\n                color: $develop-color;\n            }\n\n            &>a {\n                margin-left: 0px;\n            }\n\n            &.d-flex {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n\n                div:first-child {\n                    padding-right: 10px;\n                }\n\n                div:nth-child(2) {\n                    span {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        .tooltipicon {\n            position: relative;\n            font-size: 18px;\n            display: inline-block;\n\n            i {\n                color: $develop-color;\n            }\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $develop-color;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 13px;\n                font-family: 'Open Sans', sans-serif;\n                line-height: 1.5;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n\n    }\n\n    .cn-section-heading {\n        display: flex;\n        align-items: center;\n        margin-top: 40px;\n        margin-bottom: 10px;\n        padding: 14px 24px;\n        background-color: lighten($develop-color, 48%);\n        border-left: 4px solid $develop-color;\n        border-radius: 0 6px 6px 0;\n\n        @media #{$mq-sm} {\n            padding: 12px 16px;\n            margin-top: 30px;\n        }\n\n        &__title {\n            font-size: 22px;\n            font-family: $muso-700 !important;\n            font-weight: normal !important;\n            color: $develop-color;\n            margin: 0;\n            line-height: 1.3;\n            letter-spacing: 0.5px;\n\n            @media #{$mq-sm} {\n                font-size: 18px;\n            }\n        }\n\n        &__btn {\n            margin-left: 16px;\n            padding: 6px 20px;\n            font-size: 14px;\n            font-family: 'Open Sans', sans-serif;\n            font-weight: 600;\n            color: #fff;\n            background-color: $develop-color;\n            border: none;\n            border-radius: 4px;\n            cursor: pointer;\n            transition: opacity 0.2s ease;\n\n            &:hover {\n                opacity: 0.85;\n            }\n        }\n    }\n\n    app-develop-challenge-top-ideas,\n    app-develop-challenge-solution-prototype,\n    app-develop-challenge-pluses,\n    app-develop-challenge-opportunities,\n    app-develop-challenge-issues,\n    app-develop-challenge-new-thinking,\n    app-develop-challenge-solution {\n        display: block;\n        margin-top: 30px;\n    }\n\n    app-develop-challenge-pluses {\n        margin-top: 10px;\n    }\n\n    app-develop-challenge-solution {\n        margin-top: 40px;\n    }\n\n    .card-default {\n\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding: 15px 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $develop-color;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n            }\n\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.stCard__body {\n                border: none;\n\n                .card-body__inner {\n                    padding: 0 !important;\n                }\n\n                .card-body__subtitle {\n                    padding: 0 40px 5px !important;\n                    margin-bottom: 0;\n                }\n            }\n\n            &.card-show {\n                display: block;\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2,\n                &--row {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n                        margin-bottom: 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n\n                &--cc {\n                    display: block;\n                    column-count: 2;\n\n                    @media #{$mq-sm} {\n                        column-count: 1;\n                    }\n\n                    &>div {\n                        -webkit-column-break-inside: avoid;\n                        page-break-inside: avoid;\n                        break-inside: avoid;\n                    }\n                }\n\n                &--3 {\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n                        margin-bottom: 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &__listwidthdot {\n\n                ul {\n                    padding-left: 30px;\n                }\n            }\n\n            &__subtitle {\n                padding-left: 35px;\n                margin-bottom: 16px;\n                position: relative;\n\n                &--convtxt {\n                    padding-left: 31px;\n                }\n\n                &>span {\n                    position: absolute;\n                    top: 0;\n                    right: 2px;\n                    opacity: 0.7;\n                    cursor: pointer;\n\n                    &.thinkeyebtn {\n                        right: 40px;\n                    }\n\n                }\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n\n            &__strength {\n                p {\n                    &.pl20 {\n                        padding-left: 20px;\n                    }\n                }\n\n                &>* {\n                    margin-bottom: 0;\n\n                    &+* {\n                        margin-top: 4px;\n                    }\n                }\n\n                &+div {\n                    margin-top: 20px;\n                }\n            }\n\n            &__solutionstable {\n                margin-bottom: 20px;\n\n                table {\n                    width: 100%;\n                }\n\n                th,\n                td {\n                    padding: 15px 15px 15px 0;\n                    vertical-align: top;\n                    width: 50%;\n                }\n\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 2px;\n                    margin-right: 6px;\n                    opacity: 0.6;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        position: absolute;\n                        color: $clarify-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $clarify-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            a {\n                i {\n                    color: #676a6c;\n                }\n            }\n\n            .fa.fa-check.disabled {\n                opacity: 0.7;\n            }\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: auto !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                @media #{$mq-sm} {\n                    font-size: 14px;\n                }\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 3px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $develop-color;\n                        background-color: $develop-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                margin: 0;\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-develop {\n                    background-color: $develop-color;\n                    border-color: $develop-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $develop-color;\n                        border: 1px solid $develop-color;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        @media #{$mq-sm} {\n                            padding-right: 7px;\n                            padding-left: 7px;\n                        }\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        em {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    em {\n                        font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n                    font-weight: 900;\n                    cursor: pointer;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    i {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                        font-weight: 900;\n                    }\n\n                    &--disable {\n                        opacity: 0.5;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        color: $body-content-color;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n                        border: 0;\n                        cursor: pointer;\n\n                        &:hover {\n                            color: #000;\n                        }\n                    }\n\n                    &--close {\n                        border-color: $develop-color;\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                        border-color: #6d6e71;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n                        @include transition-slow();\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                            font-weight: 900;\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        em {\n                            font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n        .strengthen-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n\n            input {\n                height: 35px;\n                padding: 10px 15px;\n                border: 1px solid $develop-color;\n                border-radius: 4px;\n                margin-bottom: 15px;\n            }\n        }\n\n        .input-tabs.cdk-drag {\n            width: 100% !important;\n\n            p {\n                margin-bottom: 5px;\n            }\n        }\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $clarify-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n                }\n\n                .card-body__minus {\n\n                    &--hide {\n                        display: none;\n                    }\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &.card-body__editcol.hideblk {\n                        display: none;\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n\n                    &:focus,\n                    &:focus-visible {\n                        outline: none;\n                    }\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        @include fflex();\n                        @include fflex-aic();\n                        justify-content: center;\n                        text-align: center;\n\n                        label {\n                            margin-bottom: 0;\n                        }\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                            padding-right: 60px;\n\n                            input {\n\n                                &:focus,\n                                &:focus-visible {\n                                    outline: none;\n                                }\n                            }\n                        }\n\n                        label {\n                            margin-bottom: 0;\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        // width: 315px;\n                        width: 158px;\n                        padding-right: 15px;\n\n                        &--wd {\n                            width: 255px;\n                        }\n\n                        select {\n\n                            &:focus {\n                                outline: $develop-color;\n                            }\n                        }\n\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            padding-right: 0;\n                            margin-bottom: 10px;\n                        }\n                    }\n\n                    &>.card-body__editinput {\n                        // width: calc(100% - 351px);\n                        width: calc(100% - 195px);\n                        padding-right: 60px;\n\n                        &--wd {\n                            width: calc(100% - 260px);\n                        }\n\n                        &--ce {\n                            position: relative;\n\n                            .converge-icon {\n                                position: absolute;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                left: 7px;\n                                font-size: 26px;\n                                color: $develop-color;\n\n                                &:hover>.card-body__tooltip,\n                                &:active>.card-body__tooltip {\n                                    display: block;\n                                }\n\n                                .card-body__tooltip {\n                                    display: none;\n                                    font-size: 16px;\n                                    color: #676a6c;\n                                    position: absolute;\n                                    bottom: 100%;\n                                    left: 0;\n                                    background: #fff;\n                                    padding: 5px;\n                                    border-radius: 5px;\n                                    box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                    width: max-content;\n                                }\n                            }\n\n                            input {\n                                padding-left: 26px;\n\n                                &:focus,\n                                &:focus-visible {\n                                    outline: none;\n                                }\n                            }\n\n                        }\n\n                        input {\n                            padding-right: 70px;\n\n                            &:focus,\n                            &:focus-visible {\n                                outline: none;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            ;\n                        }\n\n                        .input-group-text {\n                            @media #{$mq-sm} {\n                                top: auto;\n                                transform: translate(0);\n                                bottom: 9px;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    margin: 0 35px;\n                    color: $body-content-color;\n                    @include transition-slow();\n\n                    &:hover {\n                        background-color: $develop-color;\n                        border: 1px solid $develop-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .breakthrough-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n\n            input {\n                height: 35px;\n                padding: 10px 15px;\n                border: 1px solid $develop-color;\n                border-radius: 4px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 0;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $develop-color;\n                border-color: $develop-color;\n                color: #fff;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &>div {\n                width: 50%;\n\n                &.card__body--cswrapper {\n                    width: 100%;\n                    position: relative;\n                    border-bottom: 1px solid #e4e4e4;\n                    padding-bottom: 5px;\n                    margin-bottom: 10px;\n\n                    &>div {}\n\n                    &::before,\n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        bottom: -1px;\n                        right: calc(100%);\n                        width: 40px;\n                        height: 1px;\n                        background-color: #e4e4e4;\n                    }\n\n                    &::after {\n                        right: auto;\n                        left: calc(100%);\n                    }\n                }\n            }\n\n            // &>div {\n            //     width: 50%;\n            // }\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            &--tc {\n                border-bottom: 1px solid #e4e4e4;\n                margin-bottom: 10px;\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n\n        &.editmodeActive {\n            @include fflex();\n            justify-content: space-between;\n            box-shadow: none;\n            background: #fff;\n            padding: 40px 35px;\n            position: relative;\n\n            &--not {\n                padding: 0;\n            }\n\n            .editinput {\n                &.top_idea {\n                    width: 100%;\n                }\n\n                &.gridView {\n                    &>.card-body__petopcol {\n                        display: grid;\n                        grid-template-columns: repeat(2, 1fr);\n                        grid-gap: 15px;\n\n                        @media #{$mq-sm} {\n                            grid-template-columns: 1fr;\n                        }\n\n                        .EditmodeInputs {\n\n                            &>f-col-12 {\n                                height: 100%;\n                            }\n                        }\n\n                        &--1 {\n                            grid-template-columns: 1fr;\n                        }\n\n                        &--3 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 3;\n                            }\n                        }\n\n                        &--4 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 4;\n                            }\n                        }\n\n                        &--5 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 5;\n                            }\n                        }\n\n                        &--6 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 6;\n                            }\n                        }\n\n                        &--7 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 7;\n                            }\n                        }\n\n                    }\n                }\n\n                &.listView {\n                    width: 100%;\n\n                    .EditmodeInputs {\n\n                        &+div {\n                            margin-top: 15px;\n                        }\n\n                        .f-col-12 {\n                            float: none;\n                        }\n                    }\n\n                }\n\n                &.individualView {\n                    .card-body__petopcol {\n                        @include fflex();\n                        justify-content: space-between;\n                        margin: 0 -15px;\n\n                        .EditmodeInputs {\n                            flex: 1;\n                            padding: 0 7px;\n\n                            @media #{$mq-sm} {\n                                flex: none;\n                                width: 100%;\n\n                                &+div {\n                                    margin-top: 15px;\n                                }\n                            }\n\n                            .row {\n                                margin-right: 0;\n                                margin-left: 0;\n                            }\n                        }\n                    }\n                }\n\n                .f-col-12 {\n                    background-color: #EBEBEB;\n                    // margin: 5px;\n                    border: 1px solid $cn-border-color;\n                    border-radius: 6px;\n                    overflow: hidden;\n\n                    .card-body__petopcol {\n                        padding: 10px 15px;\n\n                        h3,\n                        h4 {\n                            margin-bottom: 5px;\n                            color: $develop-color;\n                            font-size: 18px;\n                            white-space: nowrap;\n\n                            a {\n                                i {\n                                    cursor: pointer;\n                                    font-size: 0.9em;\n                                    color: $develop-color;\n                                }\n                            }\n                        }\n\n                        &--ideateclr {\n                            h3 {\n                                color: #676A6C;\n\n                                a {\n                                    i {\n                                        color: #676A6C;\n                                    }\n                                }\n                            }\n                        }\n\n                        p {\n                            font-weight: 600;\n                        }\n\n                        .card-body__finalstate {\n                            position: relative;\n\n                            &.SolutionHeight {\n\n                                // height: 100%!important;\n                                span {\n                                    svg {\n                                        transform: rotate(0deg);\n                                        cursor: pointer;\n                                    }\n                                }\n                            }\n\n                            span {\n                                position: absolute;\n                                bottom: -12px;\n                                right: -5px;\n\n                                svg {\n                                    transform: rotate(180deg);\n                                    cursor: pointer;\n                                }\n                            }\n\n                            &.TopIdeasInput {\n                                span {\n                                    cursor: pointer;\n                                    position: relative;\n                                    top: 0;\n                                    left: 10px;\n\n                                    svg {\n                                        width: 10px;\n                                        transform: rotate(180deg);\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n\n                input {\n\n                    &:focus,\n                    &:focus-visible {\n                        outline: none;\n                    }\n                }\n            }\n        }\n\n        &.ediMode__pf {\n            margin-top: 0;\n\n            &--wbg {\n                background-color: #fff;\n            }\n\n            &>span {\n                padding: 2px 16px;\n                background-color: #6d6e71;\n                color: #fff;\n                margin-left: 40px;\n                border-radius: 5px;\n                border-bottom-left-radius: 0;\n                border-bottom-right-radius: 0;\n                font-size: 10px;\n            }\n\n            .card-body--ebtn {\n                margin-top: 0;\n                padding: 15px 40px;\n\n                @media #{$mq-md} {\n                    padding: 12px 20px;\n                }\n\n                .card-body--ebtnrow {\n                    // padding: 0 15px;\n                }\n            }\n\n            .new-thinking {\n                background-color: #fff;\n            }\n\n            .card-body__ipwrap {\n                // padding-right: 24px;\n            }\n\n            .card-body--ebtnrow>div {\n                // margin-left: 25px;\n                // padding: 10px;\n            }\n\n            .card-body__inner {\n                padding: 0;\n            }\n\n            .info {\n                padding: 14px 40px;\n\n                @media #{$mq-md} {\n                    padding: 12px 20px;\n                }\n\n            }\n\n            .card-body__backouter {\n                border-bottom: 1px solid $cn-border-color;\n                padding-right: 40px;\n                padding-bottom: 50px;\n                padding-left: 40px;\n\n                // min-height: 400px;\n                &.plus {\n                    // min-height: 480px;\n                }\n\n                &-headingmobile {\n                    display: none;\n\n                    @media #{$mq-sm} {\n                        display: block;\n                    }\n                }\n\n                &-headingdesk {\n                    padding-left: 13px;\n\n                    @media #{$mq-sm} {\n                        display: none;\n                    }\n\n                    .card-body__ipwrap {\n                        margin-bottom: 0;\n                    }\n\n                    .card-body__ipcol {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &-pincontent {\n                    overflow-y: auto;\n                    overflow-x: hidden;\n                }\n\n                @media #{$mq-md} {\n                    padding-right: 20px;\n                    padding-left: 20px;\n                }\n\n            }\n\n            .card-body__pe {\n                border-bottom: none;\n\n                &>div {\n                    padding: 0;\n                }\n\n                h4 {\n                    font-size: 25px;\n                    color: #fff;\n                    font-family: \"Museo-700\";\n                    font-weight: 700;\n                    white-space: nowrap;\n\n                    @media #{$mq-md} {\n                        font-size: 18px;\n                    }\n\n                    @media #{$mq-sm} {\n                        font-size: 15px;\n                        padding-left: 35px;\n                        word-break: break-word;\n                        white-space: normal;\n                    }\n\n                    .card__bwnh3ai {\n                        display: inline-flex;\n                        align-items: center;\n                        vertical-align: middle;\n                        margin-left: 6px;\n                        padding: 6px 8px;\n                        cursor: pointer;\n                        color: #fff;\n                        font-size: 14px;\n                        border-radius: 4px;\n                        transition: opacity 0.2s ease;\n\n                        &:hover {\n                            opacity: 0.7;\n                        }\n\n                        i {\n                            font-size: 14px;\n                        }\n                    }\n\n                    &::before {\n                        background-color: #fff;\n                        color: $develop-color;\n                        font-family: \"Museo-700\";\n                        font-weight: 700;\n\n                        @media #{$mq-sm} {\n                            width: 20px;\n                            height: 20px;\n                            font-size: 15px;\n                        }\n                    }\n                }\n\n                .card-body__petop {\n                    background-color: $develop-color;\n                    position: relative;\n\n                    .card__topcol--tt {\n\n                        .tooltipicon__icon {\n                            color: #fff;\n                            cursor: pointer;\n                        }\n                    }\n\n                    .card-body__petoprow {\n\n                        // width: 85%;\n                        @media only screen and (max-width:1199px) {\n                            // width: 90%;\n                        }\n\n                        .card-body__petopcol {\n\n                            @media only screen and (max-width: 1199px) {\n                                // width: calc(100% /2);\n                            }\n\n                            &.card-body__petopcol--tab {\n                                ul {\n                                    li {\n                                        button {\n                                            min-height: 40px;\n                                            padding: 6px 24px;\n                                            background-color: #fff;\n                                            color: $develop-color;\n\n                                            @media #{$mq-md} {\n                                                padding: 4px 6px;\n                                                font-size: 13px;\n                                                min-height: auto;\n                                                height: auto;\n                                                width: auto;\n                                            }\n\n                                            svg {\n                                                .st0 {\n                                                    fill: #fff\n                                                }\n                                            }\n                                        }\n                                    }\n\n                                }\n\n                                &.card-body__petopcol--ctt {\n                                    position: relative;\n\n                                    ul {\n                                        li {\n                                            .card-body__tooltip {\n                                                display: none;\n                                                position: absolute;\n                                                background: #fff;\n                                                color: #676a6c;\n                                                padding: 5px;\n                                                top: -27px;\n                                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                                border-radius: 5px;\n                                                width: max-content;\n\n                                            }\n\n                                            button {\n\n                                                &:hover {\n                                                    opacity: 0.2 !important;\n                                                }\n\n                                            }\n\n                                            &:hover,\n                                            &:active {\n\n                                                .card-body__tooltip {\n                                                    display: block;\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n\n\n\n                            &.card-body__petopcol--title {\n                                &>div:first-child {\n                                    width: 245px;\n                                }\n\n                                .plus {\n                                    h4::before {\n                                        content: \"P\" !important;\n                                    }\n                                }\n\n                                .opp {\n                                    h4::before {\n                                        content: \"O\" !important;\n                                    }\n                                }\n\n                                .issue {\n                                    h4::before {\n                                        content: \"I\" !important;\n                                    }\n                                }\n\n                                .solution_pro_st {\n                                    width: 300px !important;\n                                    margin-left: -40px;\n\n                                    h4:before {\n                                        display: none;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $develop-color;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .card-body__pe {\n        padding: 0px;\n        border: 1px solid $cn-border-color;\n        margin-bottom: 20px;\n        @include fflex();\n        float: none;\n\n        &--npnb {\n            border: none;\n            margin-bottom: 0;\n\n            .pluses {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n            }\n\n            .opportunities {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n            }\n\n            .issues {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n            }\n\n            .new-thinking {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n\n                .card-body__ipwrap {\n                    margin-bottom: 0;\n\n                    .card-body__ipcol:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n\n        .card-body__petop {\n            margin-bottom: 13px;\n\n            .card-body__petoprow {\n                @include fflex();\n\n                .card-body__petopcol {\n                    padding: 0 15px;\n\n                    &--full {\n                        width: 100% !important;\n                    }\n\n                    &:nth-child(1) {\n                        width: 28%;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                        }\n                    }\n\n                    &:nth-child(2) {\n                        width: 44%;\n\n                        @media #{$mq-sm} {\n                            width: 120px;\n                        }\n                    }\n\n                    &:nth-child(3) {\n                        width: 28%;\n                        text-align: right;\n\n                        @media #{$mq-sm} {\n                            width: auto;\n                        }\n                    }\n\n\n\n                    &.card-body__petopcol--title {\n                        @include fflex();\n                        @include fflex-aic();\n\n                        &>div:first-child {\n                            width: 215px;\n                            padding-right: 15px;\n\n                            @media #{$mq-sm} {\n                                width: auto;\n                                padding-right: 5px;\n                            }\n                        }\n\n                        &>div:nth-child(2) {\n                            width: calc(100% - 216px);\n                        }\n\n                        button.card__h3button {\n                            border: 1px solid $develop-color;\n                            background-color: transparent;\n                            padding: 4px 26px;\n                            border-radius: 3px;\n                            @include headingfont();\n                            color: $develop-color;\n                            font-size: 22px;\n                            transition: all ease 0.3s;\n                            cursor: pointer;\n\n                            &:hover {\n                                background-color: $develop-color;\n                                color: #fff;\n                            }\n\n                            &:focus {\n                                outline: none;\n                            }\n                        }\n                    }\n\n                    &.card-body__petopcol--startexist {\n                        width: 65%;\n                    }\n\n                    &.card-body__petopcol--tab {\n                        @include fflex();\n                        @include fflex-jcc();\n\n                        ul {\n                            @include fflex();\n                            flex-wrap: nowrap;\n                            margin: 0;\n                            padding: 0;\n                            border-radius: 3px;\n\n                            li {\n                                list-style: none;\n\n                                &:first-child {\n                                    button {\n                                        svg {\n                                            right: calc(100% + 1px)\n                                        }\n\n                                        span.card__topcount {\n                                            @media only screen and (max-width: 630px) {\n                                                left: -30px;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                &:last-child {\n                                    button {\n                                        svg {\n                                            left: calc(100% + 1px);\n                                        }\n\n                                        span.card__topcount {\n                                            @media only screen and (max-width: 630px) {\n                                                right: -30px;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                &:only-child {\n                                    button {\n                                        border-radius: 3px;\n                                    }\n                                }\n\n                                &.card__topactive {\n                                    button {\n                                        color: $develop-color;\n                                        border: 1px solid $develop-color;\n\n                                        span.card__topcount {\n                                            color: $develop-color;\n                                            background-color: #efefef;\n\n                                            &.redConverge_count {\n                                                background-color: #EC2121;\n                                                color: #fff;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                &.card__topcomplete {\n                                    button {\n                                        opacity: 0.2;\n                                        border: 1px solid $develop-color;\n                                        color: $develop-color;\n\n                                        span.card__topcount {\n                                            color: $develop-color;\n                                            background-color: #efefef;\n\n                                            &.redConverge_count {\n                                                background-color: #EC2121;\n                                                color: #fff;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                button {\n                                    position: relative;\n                                    color: $develop-color;\n                                    font-size: 17px;\n                                    padding: 6px 14px;\n                                    @include headingfont();\n                                    display: inline-block;\n                                    height: 100%;\n                                    border: 0;\n                                    border: 1px solid #7bbc43;\n                                    height: auto;\n                                    min-height: 42px;\n                                    background-color: transparent;\n                                    @include transition-slow();\n                                    -webkit-appearance: none;\n                                    -moz-appearance: none;\n                                    appearance: none;\n\n                                    svg {\n                                        position: absolute;\n                                        top: -1px;\n                                        height: calc(100% + 2px);\n\n                                        .st0 {\n                                            fill: $develop-color;\n                                        }\n                                    }\n\n                                    @media only screen and (max-width: 630px) {\n                                        padding: 6px 0;\n                                        border: 0 !important;\n                                        width: 0;\n                                        height: 24px;\n                                        min-height: auto;\n                                    }\n\n                                    @media only screen and (min-width:630px) and (max-width: 991px) {\n                                        padding: 6px 7px;\n                                    }\n\n                                    &:focus {\n                                        outline: none;\n                                        box-shadow: none;\n                                    }\n\n                                    &>.card__topdesktext {\n                                        @media only screen and (max-width: 1180px) {\n                                            display: none;\n                                        }\n                                    }\n\n                                    &>.card__topmobiletext {\n                                        display: none;\n\n                                        @media only screen and (max-width: 1180px) {\n                                            display: inline-block;\n                                        }\n\n                                    }\n\n                                    &>span.card__topcount {\n                                        width: 16px;\n                                        height: 16px;\n                                        line-height: 16px;\n                                        display: inline-block;\n                                        text-align: center;\n                                        font-size: 0.5em;\n                                        background-color: $develop-color;\n                                        color: #fff;\n                                        margin-left: 4px;\n                                        border-radius: 50%;\n                                        vertical-align: bottom;\n                                        position: relative;\n                                        top: -1px;\n\n                                        @media only screen and (max-width: 630px) {\n                                            position: absolute;\n                                            top: auto;\n                                            bottom: -2px;\n                                            right: 0;\n                                            margin: 0;\n                                        }\n                                    }\n\n                                    &:hover {\n                                        color: $develop-color;\n                                        opacity: 1;\n                                    }\n\n                                    &:hover>span.card__topcount {\n                                        color: $develop-color;\n                                        background-color: #efefef;\n                                        opacity: 1;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    &.card-body__petopcol--info {\n                        text-align: right;\n\n                        .tooltipicon {\n                            cursor: pointer;\n                            position: relative;\n                            font-size: 18px;\n                            display: inline-block;\n\n                            i {\n                                color: #7bbc43;\n                            }\n                        }\n                    }\n\n                }\n\n                p.new-think-issue {\n                    margin-top: 10px;\n                }\n\n                .convergeMsg {\n                    width: calc(100%/3);\n                }\n            }\n\n\n        }\n\n        &>div {\n            padding: 25px;\n\n            @media only screen and (max-width: 767px) {\n                width: 100%;\n            }\n        }\n\n        .pluses {\n            border-bottom: 1px solid $cn-border-color;\n\n            h4::before {\n                content: \"P\";\n            }\n        }\n\n        .opportunities {\n            border-bottom: 1px solid $cn-border-color;\n\n            h4::before {\n                content: \"O\";\n            }\n        }\n\n        .issues {\n            border-bottom: 1px solid $cn-border-color;\n\n            h4::before {\n                content: \"I\";\n            }\n        }\n\n        .new-thinking {\n            h4::before {\n                content: \"Nt\";\n            }\n        }\n\n        // .pluses > form, .opportunities > form, .issues > form, .new-thinking > form, .card-body__backouter {\n        //     padding-left: 52px;\n        // }\n        h4 {\n            position: relative;\n            padding-left: 50px;\n            color: $develop-color;\n            font-size: 19px;\n            margin: 0 0 0;\n            font-family: 'Open Sans', sans-serif;\n\n            @media #{$mq-sm} {\n                padding-left: 35px;\n            }\n\n            &::before {\n                content: \"\";\n                background: $develop-color;\n                color: #fff;\n                font-size: 20px;\n                height: 35px;\n                width: 35px;\n                position: absolute;\n                border-radius: 50%;\n                top: 0;\n                left: 0;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                justify-content: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                @media #{$mq-sm} {\n                    width: 25px;\n                    height: 25px;\n                }\n            }\n\n            small {\n                display: block;\n                margin-top: 4px;\n                color: inherit;\n                line-height: 1.3;\n                font-size: 14px;\n                color: #888;\n            }\n        }\n\n        span.fill-bottom {\n            width: 100%;\n            color: #888;\n            font-size: 15px;\n        }\n\n        .icons-right {\n            i {\n                font-size: 21px;\n                color: $develop-color;\n                cursor: pointer;\n\n                &:not(:last-child) {\n                    margin-right: 10px;\n                }\n            }\n        }\n\n        .fill-input {\n            width: calc(100% - 35px);\n            display: inline-block;\n            margin-right: 15px;\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n            }\n\n            input {\n                display: inline-block;\n                width: calc(100% - 20px);\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n        }\n\n        .input-tabs {\n            .input-tabs__row {\n                width: calc(100% - 35px);\n                display: inline-block;\n                margin-right: 15px;\n                position: relative;\n                vertical-align: middle;\n\n                .pr-0 {\n                    padding-right: 0;\n                }\n\n                &>i {\n                    position: absolute;\n                    top: 50%;\n                    right: -26px;\n                    -webkit-transform: translateY(-50%);\n                    -ms-transform: translateY(-50%);\n                    transform: translateY(-50%);\n                }\n            }\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n            }\n\n            input,\n            select {\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n\n            select {\n                display: inline-block;\n                width: calc(100% - 20px);\n            }\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n        }\n    }\n\n    .develop-footer-note {\n        color: $develop-color;\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .dotactions {\n        position: relative;\n\n        .dotactions__inner {\n            position: absolute;\n            top: 0;\n            right: 0;\n\n            &--h {\n                top: 5px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    width: 17px;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                }\n            }\n\n            &--v {\n                right: 10px;\n                top: 11px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    -webkit-box-orient: vertical;\n                    -webkit-box-direction: normal;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                    height: 21px;\n                    width: 11px;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n                }\n            }\n\n            .dotactions__top {\n                padding-bottom: 4px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                span {\n                    background-color: #adadad;\n                    width: 3px;\n                    height: 3px;\n                    border-radius: 50%;\n                }\n            }\n\n            .dotactions__dropdown {\n                display: none;\n                background-color: #fff;\n                position: absolute;\n                top: 100%;\n                width: 150px;\n                box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                right: -5px;\n                border-radius: 4px;\n                z-index: 9;\n                border: 1px solid #ddd;\n\n                .dotactions__close {\n                    cursor: pointer;\n                    position: absolute;\n                    top: 5px;\n                    right: 6px;\n                    font-size: 11px;\n                    -webkit-transition: all ease 0.3s;\n                    -o-transition: all ease 0.3s;\n                    transition: all ease 0.3s;\n\n                    &:hover {\n                        -webkit-transform: rotate(360deg);\n                        -ms-transform: rotate(360deg);\n                        transform: rotate(360deg);\n                    }\n                }\n\n                .dotactions__dropdowninner {\n                    display: none;\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    width: 200px;\n                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                    border-radius: 4px;\n                    padding: 18px;\n                    background: #fff;\n                    border: 1px solid #ddd;\n\n                    .dotactions__dropdownin {\n                        padding: 10px 10px;\n                        border-radius: 4px;\n                        min-height: 100%;\n                        background-color: #f4f4f4;\n\n                        h6 {\n                            margin: 0;\n                            font-size: 13px;\n                            font-weight: 600;\n                            margin-bottom: 6px;\n                        }\n                    }\n                }\n\n                &>h6 {\n                    text-align: center;\n                    margin: 0;\n                    font-size: 13px;\n                    padding: 8px 10px;\n                    border-bottom: 1px solid #eee;\n                    font-weight: 400;\n                    margin-bottom: 2px;\n                    background-color: #f4f4f4;\n                }\n\n                li {\n                    margin: 0;\n\n                    a {\n                        padding: 6px 12px;\n                        color: #656565;\n                        display: block;\n                        font-weight: 400;\n\n                        &:hover {\n                            background-color: rgba(9, 30, 66, .04);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .ideate__ipwrap {\n        overflow-x: auto;\n        padding: 4px 0 20px !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .card-body__ipwrap {\n        padding: 4px 0 100px;\n        margin: 0 -15px 10px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        &m0p0 {\n            margin-bottom: 0;\n            padding-bottom: 0 !important;\n        }\n\n        &--gutter0 {\n            margin: 0 !important;\n            padding: 0;\n        }\n\n        &--scrollx {\n            padding-bottom: 20px !important;\n            -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n            overflow-x: auto;\n\n            &>div {\n                &:not(:last-child) {\n                    margin-right: 30px;\n                }\n            }\n        }\n\n        .card-body__ipcolumn {\n            max-width: 250px;\n            padding: 0 0;\n            width: 100%;\n            -webkit-box-flex: 0;\n            -ms-flex: 0 0 250px;\n            flex: 0 0 250px;\n\n            .card-body__listwidthdot {\n                margin-bottom: 10px;\n                margin-bottom: 0;\n                border: 1px solid $body-content-color;\n\n                &>div {\n                    padding: 10px;\n\n                    p {\n                        position: relative;\n\n                        &::before {\n                            position: absolute;\n                            top: 8px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n                    }\n                }\n\n                &_converge {\n                    border: none;\n                }\n            }\n\n            // &:first-child{\n            //     .card-body__listwidthdot {\n            //         border: 0;\n            //         & > div {\n            //             padding: 10px 10px 10px 0;\n            //         }\n            //     }\n            // }\n        }\n\n        &.card-body__ipwrap--pb0 {\n            padding-bottom: 0;\n        }\n\n        .card-body__ipcol {\n            padding: 0 15px;\n            margin-bottom: 20px;\n            width: calc(100% / 2);\n\n            @media only screen and (max-width: 1080px) {\n                width: calc(100% / 2);\n            }\n\n            @media #{$mq-sm} {\n                width: 100%;\n            }\n\n            .card-body__ipaddcol {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                &>.form-control {\n                    width: calc(100% - 91px);\n                }\n\n                .input-group-postpend {\n                    width: 90px;\n\n                    button {\n                        border-top-left-radius: 0;\n                        border-bottom-left-radius: 0;\n                    }\n                }\n            }\n\n            &--ideate {\n                padding: 0;\n                margin-bottom: 0px;\n                max-width: 270px;\n                width: 100%;\n                flex: 0 0 270px;\n                -webkit-flex: 0 0 270px;\n                -ms-flex: 0 0 270px;\n\n                .checkbox {\n                    padding-right: 22px;\n                }\n\n                &+div {\n                    margin-left: 30px;\n                }\n\n                @media only screen and (max-width: 1080px) {\n                    width: calc(100% / 2);\n                }\n\n                @media only screen and (max-width: 600px) {\n                    width: calc(100%);\n                }\n\n                h2 label {\n                    font-size: 15px;\n                }\n            }\n        }\n\n        h2 {\n            margin-top: 0;\n            color: #656565;\n            font-size: 14px;\n            font-weight: 500;\n            margin-bottom: 12px;\n\n            label {\n                display: inline-block;\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n\n                &+span {\n                    position: relative;\n                    top: -2px;\n                    margin: 0 10px 0 0;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    text-align: center;\n\n                    &::before {\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked+span {\n                    background-color: #5D9CEC;\n                    border-color: #5D9CEC;\n                }\n\n                &:checked+span::before {\n                    opacity: 1;\n                }\n            }\n        }\n\n        ul {\n            padding: 0;\n            margin: 0;\n\n            li {\n                list-style: none;\n                padding: 0;\n                width: 100%;\n\n                .card-body__edit {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    -ms-flex-wrap: wrap;\n                    flex-wrap: wrap;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n\n                    .form-control {\n                        height: 45px;\n                    }\n\n                    &>i {\n                        margin-left: auto;\n                        cursor: pointer;\n                        color: $develop-color;\n                    }\n                }\n\n                &:last-child {\n                    .card-body__edit {\n                        input {\n                            width: calc(100% - 30px);\n                        }\n                    }\n                }\n\n                .card-body__ipinner {\n                    display: block;\n                    font-size: 15px;\n                    position: relative;\n                    border: 1px solid #ccc;\n                    padding: 10px;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n\n    .compare-sol {\n        width: 49%;\n        float: left;\n    }\n\n    .fullwidth {\n        width: 100%;\n        display: block;\n    }\n\n    .card_solution {\n        b {\n            font-size: 15px;\n        }\n\n        .solution-list {\n            margin-bottom: 10px;\n            width: 100%;\n            margin-top: 10px;\n\n            span {\n                display: block;\n            }\n\n            &__selection1 {\n                margin-top: 10px;\n            }\n\n            &__selection2 {\n                margin-left: 20px;\n            }\n        }\n    }\n}\n\n\n.develop-is .card-body__ipwrap ul li {\n    position: relative;\n\n    input[type=\"checkbox\"] {\n        position: absolute;\n        top: 11px;\n        left: 10px;\n        z-index: 2;\n\n        &+label {\n            padding-left: 31px;\n        }\n    }\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -550px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &--videoexist {\n        max-width: 735px;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $develop-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $develop-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $develop-color;\n                @include transition-slow();\n\n                &::before {}\n\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $develop-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                @include fflex();\n                margin: 0;\n                position: relative;\n                color: $develop-color;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $develop-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $develop-color;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n\n    }\n\n}\n\n\n.prevnext {\n    padding: 20px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $develop-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n.playbtn {\n    position: absolute;\n    right: 8px;\n    bottom: 7px;\n\n    i {\n        color: #7bbc43;\n    }\n}\n\n.ideate-is .info .card__toprow .card__topcol.card__topcol--tt svg {\n    max-width: 16px;\n    cursor: pointer;\n}\n\n.card__toprow {\n    @include fflex();\n    @include fflex-aic();\n    margin: 0 -15px;\n\n    .card__topcol {\n        padding: 0 15px;\n\n        // width: calc( 100% / 3 );\n        &.card__topcol--tt {\n            margin-left: auto;\n            text-align: right;\n\n            svg {\n                max-width: 16px;\n                cursor: pointer;\n            }\n\n            span {\n                position: absolute;\n                right: -17px;\n                bottom: 18px;\n\n                @media only screen and (max-width: 767px) {\n                    right: 2px;\n                }\n            }\n        }\n    }\n}\n\n.stick-challenge {\n    position: relative;\n\n    .card-body__backouter {\n        min-height: auto;\n        overflow-y: auto;\n        z-index: 9;\n        position: relative;\n\n        .card-body__subtitle {\n            position: sticky;\n            top: 0;\n            z-index: 99;\n            background-color: #fff;\n        }\n\n        &.plus {\n            min-height: 400px;\n        }\n    }\n\n}\n\n// .stick-challenge-solpropin {\n//     position: relative;\n//     overflow-y: auto;\n//     height: calc(100vh - 368px);\n\n//     .card.card-default:nth-child(2) {\n//         position: sticky;\n//         top: 0;\n//         left: 0;\n//         width: 100%;\n//         background: #fff;\n//         z-index: 9;\n//     }\n// }\n.st0 {\n    fill: #7bbc43;\n    margin-right: 12px;\n}\n\n.st1 {\n    fill: none;\n    stroke: #7bbc43;\n    stroke-miterlimit: 10;\n    margin-right: 10px;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n.modal-body {\n\n    &__tr {\n        column-count: 2;\n        column-gap: 20px;\n    }\n\n    &__td {\n        -webkit-column-break-inside: avoid;\n        page-break-inside: avoid;\n        break-inside: avoid;\n    }\n\n    &__buttons {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-end;\n\n        &>button {\n\n            &:not(:last-child) {\n                margin-right: 15px;\n            }\n        }\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.row--editmodebg {\n    background-color: #fff;\n    padding: 40px 35px;\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: $develop-color;\n        background: transparent;\n        padding-left: 0;\n        font-size: 13px;\n        margin-left: 11px;\n        margin-bottom: 2px;\n        display: inline-block;\n        position: absolute;\n        top: 17px;\n    }\n}\n\n// AI icon styling for develop stage\n.card-body__pe {\n    .card-body__petop {\n        .card__bwnh3ai {\n            display: inline-flex;\n            align-items: center;\n            vertical-align: middle;\n            margin-left: 6px;\n            padding: 6px 8px;\n            cursor: pointer;\n            color: #fff;\n            font-size: 14px;\n            border-radius: 4px;\n            transition: opacity 0.2s ease;\n\n            &:hover {\n                opacity: 0.7;\n            }\n\n            i {\n                font-size: 14px;\n            }\n        }\n    }\n}\n\n.EditmodeInputs {\n    .card__bwnh3ai {\n        display: inline-flex;\n        align-items: center;\n        vertical-align: middle;\n        margin-left: 6px;\n        padding: 6px 8px;\n        cursor: pointer;\n        color: $develop-color;\n        font-size: 14px;\n        border-radius: 4px;\n        transition: opacity 0.2s ease;\n\n        &:hover {\n            opacity: 0.7;\n        }\n\n        i {\n            font-size: 14px;\n        }\n    }\n\n    h3, h4 {\n        white-space: nowrap;\n    }\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}\n\n// Modal Design\n::ng-deep .modal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    overflow: hidden;\n    -webkit-overflow-scrolling: touch;\n    outline: 0;\n\n    &.show {\n        display: block !important;\n    }\n\n    &.grey {\n        background: rgba(236, 236, 236, 0.9);\n    }\n\n    &.fade {\n        .modal-dialog {\n            transition: transform 0.3s ease-out;\n        }\n\n        &.in {\n            opacity: 1;\n        }\n    }\n\n    &.in {\n        .modal-dialog {\n            transform: translate(0, 0);\n        }\n    }\n\n    &.modal-open {\n        overflow-x: hidden;\n        overflow-y: auto;\n    }\n\n    .modal-dialog {\n        position: relative;\n        width: auto;\n        margin: 10px;\n\n        @media (min-width: 768px) {\n            width: 600px;\n            margin: 30px auto;\n        }\n\n        .modal-content {\n            background-clip: padding-box;\n            background-color: #FFFFFF;\n            border: 1px solid rgba(0, 0, 0, 0);\n            border-radius: 4px;\n            box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n            outline: 0 none;\n            position: relative;\n\n            .close {\n                float: right;\n                font-size: 21px;\n                font-weight: bold;\n                line-height: 1;\n                color: #000;\n                text-shadow: 0 1px 0 #fff;\n                filter: alpha(opacity=20);\n                opacity: 0.2;\n\n                &:focus-visible {\n                    outline: none;\n                }\n            }\n\n            button.close {\n                padding: 0;\n                cursor: pointer;\n                background: transparent;\n                border: 0;\n                -webkit-appearance: none;\n                appearance: none;\n            }\n\n            .modal-body {\n\n                form {\n\n                    .form-group {\n                        margin-bottom: 15px;\n                    }\n                }\n            }\n        }\n    }\n\n    .f-btn {\n        color: #fff;\n        font-size: 14px;\n        border-color: #73BF38;\n        background-color: #73BF38;\n\n        &:hover {\n            border-color: #4cae4c;\n            background-color: #4cae4c;\n        }\n\n        &--seagrn {\n            border-color: #1dc5a3;\n            background-color: #1dc5a3;\n\n            &:hover {\n                border-color: #1dc5a3;\n                background-color: #1dc5a3;\n            }\n        }\n\n        &--dngr {\n            color: #fff;\n            border-color: #ED5565;\n            background-color: #ED5565;\n\n            &:hover {\n                border-color: #ec4758;\n                background-color: #ec4758;\n            }\n        }\n\n        &--info {\n            color: #fff;\n            border-color: #23c6c8;\n            background-color: #23c6c8;\n\n            &:hover {\n                border-color: #21b9bb;\n                background-color: #21b9bb;\n            }\n        }\n\n        &--white {\n            background-color: #fff;\n            border-color: #ddd;\n            color: #6D6E71;\n        }\n\n        &--wrng {\n            color: #fff;\n            border-color: #f8ac59;\n            background-color: #f8ac59;\n\n            &:hover {\n                border-color: #f7a54a;\n                background-color: #f7a54a;\n            }\n        }\n    }\n}\n\n::ng-deep.modal-open {\n    overflow: hidden;\n}","// Shared Challenge Navigator mixins, breakpoints, and variables\n// Import this at the top of each stage component SCSS\n\n@import './../../../assets/styles/variables';\n\n// CN-specific variables\n$cn-border-color: #CFDBE2;\n$cn-edit-bg: #ebebeb;\n$cn-card-bg: #f5f5f5;\n\n// Breakpoints\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n// Mixins\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n@mixin headingfont() {\n    font-family: $muso-700 !important;\n    font-weight: normal !important;\n}\n\n@mixin contentfont() {\n    font-family: $muso-300 !important;\n    font-weight: normal !important;\n}\n\n// Common element resets\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
